// Generated from Logo.g4 by ANTLR 4.5.2
// jshint ignore: start
var antlr4 = require('antlr4/index');

// This class defines a complete generic visitor for a parse tree produced by LogoParser.
var INTERRUPT_INTERVAL = 5000;
/* A big amount of 'wait' gets divided into multiple 'wait's, each the length of `WAIT_INTERVAL_MS`. Otherwise we couldn't
 * interrupt the visitor during longer waits, since the visitor would be waiting on a long timer we couldn't abort.
 */
var WAIT_INTERVAL_MS = 200;

/* Setting this value to false will make the visitor continue execution
 * after encountering a run-time error. Sometimes this is possible, often
 * not.
*/
var ABORT_ON_EXCEPTION = true;

var canvas;
var variables = new Array();
var timeout = 0;
var editor;
var parameters;
var stop = false;
var isSuspended = false;
//var beenherebefore = new Array();
var inputtext;
var visitorInstance;
var speed;
var lang;
var timeCounter;
var threshold = 1000000;
var stack = new Array();
var wait = 0;
var visitorDoneCallback;
var inputComponent;
var testingMode = false;
// Every so-many-steps we suspend the visitor execution so that the UI has a chance to get scheduled.
var suspendWithState;

//  TODO: make these accessible
var CONTINUE_AFTER_CALLBACK = 1;
var STOP_AFTER_CALLBACK = 0;
var inDebugMode;
var stepOverCmds = ["Repeat", "If", "While"];


function reportError(msg, input) {
	canvas.reportError(msg, input);

	// Abort execution depending on settings
	if (ABORT_ON_EXCEPTION) {
		stopVisitor();
	}
}

function VisitorState(ctx, stack){
	this.ctx = ctx;
	this.stack = stack;
}

function LogoVisitor(text, spe, input, debug, debugCallback, doneFunction) {
	antlr4.tree.ParseTreeVisitor.call(this);
    visitorDoneCallback = doneFunction;
    inputComponent = input;
    suspendWithState = debugCallback;
    canvas = inputComponent.canvasComponent;

    //inputComponent.editor contains values only in case the input contains user-defined programs. Not needed otherwise
    //we cannot allow to read the field if it was not previously written (which is not necessary in case the editor is not actually used)
    if(inputComponent.editor){
        editor = inputComponent.editor.edit;
        parameters = inputComponent.editor.param;
    }
    
    inputtext = text;
    //beenherebefore = new Array();
    visitorInstance = this;
    speed = spe;
    stop = false;
    isSuspended = false;
    lang = inputComponent.lang;
    timeCounter = 0;
    threshold = 1000000;
    inDebugMode = debug;
    return this;
}

LogoVisitor.prototype = Object.create(antlr4.tree.ParseTreeVisitor.prototype);
LogoVisitor.prototype.constructor = LogoVisitor;

// Checks if visitor should be suspended for this command
function skippableCmd(cmd) {
	stepOver = false;
	stepOverCmds.forEach(element => {
		if (cmd.includes(element)) {
			stepOver = true;
		}
	});

	return stepOver;
}

/*
Creates a clone of context, kind of like a deep clone
Unfortunately, completely cloning the object (for example
using the clone library) renders the visitor unusably slow
*/
function cloneContext(ctx) {
    if (ctx.children == undefined) {
        return ctx;
    }

    var cpy = new ctx.constructor();
    for (key in ctx) {
        if (ctx.hasOwnProperty(key)) {
            cpy[key] = ctx[key];
        }
	}

    cpy.children = Array();
    for (var i = 0; i < ctx.children.length; i++) {
        cpy.children[i] = cloneContext(ctx.children[i]);
        cpy.children[i].parentCtx = cpy;
	}

    return cpy;
}

// stops the visitor and invokes the necessary cleanup
function stopVisitor() {
    stop = true;
    suspend(null);
    visitorDoneCallback();
}

// Get operation name from constructor of context
function getOperationName(ctx) {
	var operationConstructorString = ctx.constructor.toString().substr('function '.length);
    operationConstructorString = operationConstructorString.substr(0, operationConstructorString.indexOf('(') - 7);
    return "visit" + operationConstructorString;
}

// Updates the turtle speed
LogoVisitor.prototype.updateTurtleSpeed = function(newSpeed) {
    speed = newSpeed;
};

// Takes one step forward -> executes until next breakpoint
LogoVisitor.prototype.reenterExecution = function(state) {
    stop = false;
    isSuspended = false;
    
	// Restoring state of visitor
	ctx = state.ctx;
	stack = state.stack;
    variables = stack.pop();
    
	console.log('[VSTR] Reentering Execution');
	setTimeout(async function() {
		// Since we only break at cmds, we can safely assume childNumber = 0
		await visitChild(0, ctx);
		canvas.flush();

		// Visit remaining part of code
		let nextChildNumber = ctx.parentCtx.lastVisitedChild + 1;
		await continueExecution(ctx.parentCtx, nextChildNumber);
	}, 0);
};

/*
We need to return a copy of the stack here. It's possible that the visitor returns to
visitProcedureInvocation after calling this, which in turn pops the variable of the stack
before realising the visitor is stopped. Since objects are passed by reference this changes
the stack we returned back to the user. Hence, in order to avoid messing with the invocation
command, we just return a copy which remains untouched.
*/
function suspend(ctx){
	stack.push(variables);
	var stackCpy = stack.slice();
	var state = new VisitorState(ctx, stackCpy);
    stop = true;
    isSuspended = true;
	return suspendWithState(state);
}

/*
Continues execution after stepping forward or backward. This function is then
called recursively until the next breakpoint is reached (or the program is over).
Basically executes the remaining part of the AST and then calls the next sibling
of the current context. If there is no such sibling, it calls the next sibling of
the parent and so on. Some control structures need to be handled differently.
*/
async function continueExecution(ctx, childNumber){
	// Check if visitor needs to be stopped by now
	if (isVisitorStopped()) {
		return;
	}

	// Check if we have ended up at the root => program's over
	if (ctx.parentCtx === null && childNumber == ctx.children.length - 1) {
        visitorDoneCallback();
		return;
	}
	
	// Check wether context has more children to visit, otherwise return to parent
	let noChildren = ctx.children.length;
	if (childNumber < noChildren) {
		await visitChild(childNumber, ctx);
		await continueExecution(ctx, childNumber + 1);
		return;
	}

    /*
    In case of a ProcedureDeclaration, we are at the end of a method and want to
    set the stack up for the previous method call. For this we change the variables
    and push them back on the stack when calling suspend().
    */
    let operationName = getOperationName(ctx);
    if (operationName === "visitProcedureDeclaration") {
        variables = stack.pop();
    }

	/*
		Special case if we are in a block. In this case we do not want to call
		the next child of Block's parent but either Repeat directly, or the parent
		of if, or...
	*/
	let parentOperationName = getOperationName(ctx.parentCtx);
	switch (parentOperationName) {
		case "visitRepeat":
			/* In case of a Repeat statement, we do not want to call the next child of
			Blocks parent (Repeat), but Repeat directly in order to execute block again
            or exit the repeat loop. Also, we only execute the loop if it has not yet
            reached the end.*/
            let ctxRepeat = ctx.parentCtx;
            let noIterations = await visitChild(1, ctxRepeat);
            if (!ctxRepeat.indexCounter || ctxRepeat.indexCounter === noIterations) {
                ctxRepeat.indexCounter = undefined;
                await continueExecution(ctxRepeat.parentCtx.parentCtx, ctxRepeat.parentCtx.parentCtx.lastVisitedChild + 1);
                break;
            }

            let ctxRepeatCmd = ctxRepeat.parentCtx;
			await continueExecution(ctxRepeatCmd, 0);
			break;
		
		case "visitWhilee":
			/* In case of a while block, we act similarly to a repeat-statement.
			Instead of calling the parent after the end of the block is reached, we
			visit the while block again to check if it needs to be re-executed.
			*/
			let ctxWhileCmd = ctx.parentCtx.parentCtx;
			await continueExecution(ctxWhileCmd, 0);
			break;
		
		case "visitIfe":
			/* In case of an If staement, we want to continue after the If-block. Calling
			the second child of the corresponding command will automatically execute the
			commands following the If-statement.
			*/
			let ctxIfCmd = ctx.parentCtx.parentCtx;
			await continueExecution(ctxIfCmd, 1);
			break;
		
		default:
			// If we are not in a special block we want to continue executing the parents children
			await continueExecution(ctx.parentCtx, ctx.parentCtx.lastVisitedChild + 1);
	}
}

async function visitChild(childnumber, ctx) {
    if (isVisitorStopped()) {
        return;
    }

    /* After a certain amount of visited nodes, 
     * we ask the user whether he wants to continue the execution
     */
    timeCounter++;
    if (timeCounter > threshold) {
        if (confirm(lang.getLang()["timeout"])) {
            threshold = threshold * 2;
        } else {
            stopVisitor();
            return;
        }
    }

    // From time to time, we want to interrupt so that the scheduler gets a chance to give the UI some processing time.
    if (timeCounter % INTERRUPT_INTERVAL == 0) {
        await interrupt();
    }

	ctx.lastVisitedChild = childnumber;
    var operationName = getOperationName(ctx.children[childnumber]);

    //child is a terminal node, break
    if (operationName.indexOf("Terminal") !== -1) {
        return;
    }

    var res = await visitorInstance[operationName](ctx.children[childnumber]);
    return res;
}

LogoVisitor.prototype.stop = function() {
    stopVisitor();
}

function isVisitorStopped() {
    return stop;
}

function waitForABit(delayMs) {
    canvas.flush();
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve();//x
        }, delayMs);
    });
}

// Execute a function at some later point in time
function executeLater(functionToExecute, delayMs) {
    return new Promise((resolve) => {
        setTimeout(async function () {
            await functionToExecute()
            resolve(x);
        }, delayMs);
    });
}

// Interrupt the current execution of the visitor. This function exists to "unfreeze" the UI: If the visitor were running
// without interruptions during its calculation (e.g. when executing an XLogo program *without* `wait` in it), the visitor would use all
// computation time (even though it is technically running asynchronously - the javascript scheduler is either not very good or does not exist).
function interrupt() {
    return new Promise((resolve) => {
        setTimeout(() => { resolve(); }, 0);
    });
}

// Visit a parse tree produced by LogoParser#prog.
LogoVisitor.prototype.visitProg = function (ctx) {
    setTimeout(async function () {
        stack.push({});
        var result = await visitChild(0, ctx);
        canvas.flush();
        if (!isSuspended) {
            visitorDoneCallback();
        }
        //Added as support of the BlueBot extension
        canvas.go();
    }.bind(this), 1);
};


// Visit a parse tree produced by LogoParser#line.
LogoVisitor.prototype.visitLine = async function (ctx) {
    //parameters = stack.pop();
    for (var i = 0; i < ctx.children.length && !isVisitorStopped(); i++) {
        var res = await visitChild(i, ctx);
    }
};


// Visit a parse tree produced by LogoParser#cmd.
LogoVisitor.prototype.visitCmd = async function (ctx) {
	if (inDebugMode) {
		let operationName = getOperationName(ctx.children[0]);
		console.log('[VSTR] Visiting cmd' + operationName);
		if (!skippableCmd(operationName)) {
			console.log('[VSTR] Returning control to UI, leaving visitor.');

			// Check if debugger wants to keep executing
            let debugAnswer = suspend(ctx);
			if (debugAnswer == CONTINUE_AFTER_CALLBACK) {
				stop = false;
                isSuspended = false;
                stack.pop();
			} else {
				return;
			}
		}
	}

    if (speed >= 0) {
        await waitForABit(speed);
	}

	// Catching run-time errors
	try {
		return await visitChild(0, ctx);
	} catch(e) {
		console.log('found error');
		reportError([e], lang.getLang()["input"] + inputtext);
		return;
	}
};


// Visit a parse tree produced by LogoParser#procedureInvocation.
LogoVisitor.prototype.visitProcedureInvocation = async function (ctx) {
    //store my own variables on stack
    stack.push(variables);

    //find out my child's name and its parameter names
    var name = ctx.children[0].getText();
    var parameterNames = parameters[name];

    if (!parameterNames) {
		//canvas.print(lang.getLang()["nosuchmethod"] + name);
		throw lang.getLang()["nosuchmethod"] + name;
    }

    //make a deep copy here but not not change the actual element! for recursion purposes...
    var childContext = editor[name];
    var rootnode = cloneContext(childContext);
    rootnode.constructor = childContext.constructor;
    rootnode.parentCtx = ctx.parentCtx;

    //prepare child's variables with values
    var childVariables = new Array();

    //Check whether number of parameters provided fits expected number in procedure declaration
    if (parameterNames.length > ctx.children.length - 1) {
        //not enough paramteres provided for command
        canvas.print(lang.getLang()["procCallNotEnoughArgs"] + name);
        return;
    } else if (parameterNames.length < ctx.children.length - 1) {
        //too many paramteres provided for command
        canvas.print(lang.getLang()["procCallTooManyArgs"] + name);
        return;
	}

    //get parameter values if there are any
    for (var i = 1; i <= parameterNames.length; i++) {
        var value = await visitChild(i, ctx);
        var key = parameterNames[i - 1];
        childVariables[key] = value;
	}
    
    //prepare variables for child
    variables = childVariables;
	  
	// Start at index 2 in order to ignore the terminal node and name context
    for (var i = 2; i < rootnode.children.length && !isVisitorStopped(); i++) {
        await visitChild(i, rootnode);
    }
    variables = stack.pop();
};


// Visit a parse tree produced by LogoParser#procedureDeclaration.
LogoVisitor.prototype.visitProcedureDeclaration = async function (ctx) {//TODO: sollte nicht m�glich sein. testen!
};


// Visit a parse tree produced by LogoParser#parameterDeclarations.
LogoVisitor.prototype.visitParameterDeclarations = async function (ctx) {//TODO: sollte nicht m�glich sein. testen!
};


// Visit a parse tree produced by LogoParser#func.
LogoVisitor.prototype.visitFunc = async function (ctx) {
    return await visitChild(0, ctx);
};

// Visit a parse tree produced by LogoParser#repeat.
LogoVisitor.prototype.visitRepeat = async function (ctx) {
	// Get number of repetitions
	const noIterations = await visitChild(1, ctx);
	let startIteration = 0;

	// Check if run in debug mode and change loop execution accordingly
	if (inDebugMode) {
		// Restore index if loop was interrupted but has never finished
		if (!(ctx.indexCounter === undefined)) {
			startIteration = ctx.indexCounter;
			// If loop has reached end, reset counter and return
			if (ctx.indexCounter == noIterations) {
				ctx.indexCounter = undefined;
				return;
			}
		}

		// Iteratively call children and save counter
		for (var i = startIteration; i < noIterations && !isVisitorStopped(); i++) {
            ctx.indexCounter = i + 1;

            // Another check is needed here
            if (ctx.indexCounter == noIterations) {
                ctx.indexCounter = undefined;
            }
			await visitChild(2, ctx);
		}
	} else {
		// Simply iterate over all children, no need to save anything
		for (var i = startIteration; i < noIterations && !isVisitorStopped(); i++) {
			await visitChild(2, ctx);
		}
	}
};


// Visit a parse tree produced by LogoParser#whilee.
LogoVisitor.prototype.visitWhilee = async function (ctx) {
    var whileLoopCondition = await visitChild(2, ctx) === lang.getLang()["true"];
    // Visit the `whilee`-loop-body until the condition becomes false, or the visitor is stopped.
    while (whileLoopCondition && !isVisitorStopped()) {
        await visitChild(4, ctx);
        whileLoopCondition = await visitChild(2, ctx) === lang.getLang()["true"];
    }
};


// Visit a parse tree produced by LogoParser#block.
LogoVisitor.prototype.visitBlock = async function (ctx) {
    // Visit the whole content of the block, but abort as soon as the visitor is stopped.
    for (var i = 1; i < ctx.children.length - 1 && !isVisitorStopped(); i++) {
        var probablyMethodname = ctx.children[i].getText();

        //check if it is "[", "]" or "/r/n"
        if (ctx.children[i].getText().length > 1 || parameters[probablyMethodname] != undefined) {
            //if it is a proper command: visit it!
            await visitChild(i, ctx);
        }
    }
};


// Visit a parse tree produced by LogoParser#ife.
LogoVisitor.prototype.visitIfe = async function (ctx) {
    var condition = await visitChild(1, ctx);
    if (condition === lang.getLang()["true"]) {//TODO: Sprache
        await visitChild(2, ctx);
    } else {
        if (ctx.children.length > 3) {
            //If there exists an else branch
            await visitChild(3, ctx);
        }
    }
};


// Visit a parse tree produced by LogoParser#expression.
LogoVisitor.prototype.visitExpression = async function (ctx) {
    if (ctx.children.length === 3) {
        var operator = ctx.children[1].getText();
        var rightval = await visitChild(2, ctx);
        var leftval = await visitChild(0, ctx);

        if (isVisitorStopped()) {
            // If the visitor has been stopped, we return early, because the visitChild() calls may have returned `undefined`.
            // (technically nothing would happen if we just continued on, but if e.g. `operator` was `undefined`, we it might
            // get caught in the default case of the switch statement, if we ever implement one later, so better safe than sorry)
            return;
        }

        switch (operator) {
            case '=':
                if (leftval === rightval) {
                    return lang.getLang()["true"];
                } else {
                    return lang.getLang()["false"];
                }
                break;
            case '!=':
                if (leftval !== rightval) {
                    return lang.getLang()["true"];
                } else {
                    return lang.getLang()["false"];
                }
                break;
            case '<':
                if (leftval < rightval) {
                    return lang.getLang()["true"];
                } else {
                    return lang.getLang()["false"];
                }
                break;
            case '<=':
                if (leftval <= rightval) {
                    return lang.getLang()["true"];
                } else {
                    return lang.getLang()["false"];
                }
                break;
            case '>':
                if (leftval > rightval) {
                    return lang.getLang()["true"];
                } else {
                    return lang.getLang()["false"];
                }
                break;
            case '>=':
                if (leftval >= rightval) {
                    return lang.getLang()["true"];
                } else {
                    return lang.getLang()["false"];
                }
                break;
        }
    } else {
        // We might encounter a run-time error (such as division by 0) so we catch them here
		return await visitChild(0, ctx);
    }
};


// Visit a parse tree produced by LogoParser#comparisonOperator.
LogoVisitor.prototype.visitComparisonOperator = async function (ctx) {
    return await visitChild(0, ctx);
};


// Visit a parse tree produced by LogoParser#sExpr.
LogoVisitor.prototype.visitSExpr = async function (ctx) {
    if (ctx.children.length > 1) {
        var operations = [];
        var values = [];

        var tmp = variables;

        for (var i = 0; i < ctx.children.length - 1; i++) {
            //push values into values array and operations into operations array
            if (i % 2 == 0) {
                values.push(await visitChild(ctx.children.length - 1 - i, ctx));
            } else {
                operations.push(ctx.children[i].getText());
            }
        }
        var res = await visitChild(0, ctx);

        while (operations.length > 0) {
            var op = operations.shift();
            var v = values.pop();
            if (op === '+') {
                res += v;
            } else {
                res -= v;
            }
        }
        return res;
    } else {
        return await visitChild(0, ctx);
    }
};


// Visit a parse tree produced by LogoParser#term.
LogoVisitor.prototype.visitTerm = async function (ctx) {
    if (ctx.children.length > 1) {
        var operations = [];
        var values = [];

        for (var i = 0; i < ctx.children.length - 1; i++) {
            if (i % 2 == 0) {
                values.push(await visitChild(ctx.children.length - 1 - i, ctx));
            } else {
                operations.push(ctx.children[i].getText());
            }
        }
        var res = await visitChild(0, ctx);

        while (operations.length > 0) {
            var op = operations.shift();
            var v = values.pop();
            if (op === '*') {
                res *= v;
            } else {
                if (v === 0) {
                    throw lang.getLang()['exception_division_by_zero'];
                }
                res /= v;
            }
        }
        return res;
    } else {
        return await visitChild(0, ctx);
    }
};


// Visit a parse tree produced by LogoParser#factor.
LogoVisitor.prototype.visitFactor = async function (ctx) {
    if (ctx.children.length > 1) {
        var sign = ctx.children[0].getText();
        var val = await visitChild(1, ctx);
        if (sign === '-') {
            return -val;
        } else {
            return val;
        }
    } else {
        return await visitChild(0, ctx);
    }
};


// Visit a parse tree produced by LogoParser#nsFact.
LogoVisitor.prototype.visitNsFact = async function (ctx) {
    if (ctx.children[0].getText() === '!') {
        var value = await visitChild(1, ctx);
        if (value === lang.getLang()["true"]) {
            return lang.getLang()["false"];
        } else {
            return lang.getLang()["true"];
        }
    } else if (ctx.children.length === 3 && ctx.children[0].getText() === '(' && ctx.children[2].getText() === ')') {
        return await visitChild(1, ctx);
    } else {
        return await visitChild(0, ctx);
    }
};


// Visit a parse tree produced by LogoParser#value.
LogoVisitor.prototype.visitValue = async function (ctx) {
    return await visitChild(0, ctx);
};


// Visit a parse tree produced by LogoParser#deref.
LogoVisitor.prototype.visitDeref = async function (ctx) {
    //MARTINA TODOOOOO
    var name;

    if (ctx.children.length > 1) {
        name = ctx.children[1].children[0].getText();
    } else {
        name = ctx.children[0].getText().substr(1);
    }

    if (name in variables) {
        var value = variables[name];
    } else {
        //TODO: Vorschlag ob vielleicht eine andere Variable gemeint sein könnte, Typo
        canvas.print(lang.getLang()["variableIsNotDeclared"] + name);
        value = 0;
    }

    return value;
};


// Visit a parse tree produced by LogoParser#colorname.
LogoVisitor.prototype.visitColorname = async function (ctx) {
    var value = ctx.children[0].getText();
    var col = canvas.getColor(value);
    return col;
};

LogoVisitor.prototype.visitColornameWithoutTypingErrors = function (ctx) {
    var value = ctx.children[0].getText();
    var col = canvas.getColor(value);
    return col;
}

// Visit a parse tree produced by LogoParser#rgb.
LogoVisitor.prototype.visitRgb = async function (ctx) {
    var b = await visitChild(3, ctx);
    var g = await visitChild(2, ctx);
    var r = await visitChild(1, ctx);
    if (isVisitorStopped()) {
        // If the visitor has been stopped, we return early, because the visitChild() calls may have returned `undefined`.
        return;
    }

    if (r < 0 || r > 255 || g < 0 || g > 255 || b < 0 || b > 255) {
		let rgbColor = '[' + r + ' ' + g + ' ' + b + ']';
        throw lang.getLang()['exception_invalid_argument_rgb'] + rgbColor;
    }

    var col = canvas.getColor("rgb(" + r + "," + g + "," + b + ")");
    return col;
};


// Visit a parse tree produced by LogoParser#colornumber.
LogoVisitor.prototype.visitColornumber = async function (ctx) {
    var value = await visitChild(0, ctx);
    if (isVisitorStopped()) {
        // If the visitor has been stopped, we return early, because the visitChild() calls may have returned `undefined`.
        return;
    }

    if (value < 0 || value > 16) {
        throw lang.getLang()['exception_invalid_argument_colornumber'] + value;
    }

    var color = canvas.getColor(value);
    return color;
};


// Visit a parse tree produced by LogoParser#make.
LogoVisitor.prototype.visitMake = async function (ctx) {
    //MARTINA: NEW:
    var value = await visitChild(2, ctx);
    if (isVisitorStopped()) {
        // If the visitor has been stopped, we return early, because the visitChild() calls may have returned `undefined`.
        return;
    }
    var key = ctx.children[1].getText().substr(1);
    //key = key.substr(1, key.length);
    variables[key] = value;
};


// Visit a parse tree produced by LogoParser#print.
LogoVisitor.prototype.visitPrint = async function (ctx) {
    var value = await visitChild(1, ctx);
    if (isVisitorStopped()) {
        // If the visitor has been stopped, we return early, because the visitChild() calls may have returned `undefined`.
        return;
    }
    canvas.print(value);
};


// Visit a parse tree produced by LogoParser#quotedstring.
LogoVisitor.prototype.visitQuotedstring = async function (ctx) {
    var string = ctx.getChild(1);

    if (ctx.children.length > 3) {
        for (var i = 2; i < ctx.children.length - 1; i++) {
            string = string + " " + ctx.getChild(i);
        }
    }
    return string;
};


// Visit a parse tree produced by LogoParser#name.
LogoVisitor.prototype.visitName = async function (ctx) {
    return await visitChild(0, ctx);
};


// Visit a parse tree produced by LogoParser#fd.
LogoVisitor.prototype.visitFd = async function (ctx) {
    var value = await visitChild(1, ctx);
    if (isVisitorStopped()) {
        // If the visitor has been stopped, we return early, because the visitChild() calls may have returned `undefined`.
        return;
    }
    canvas.fd(value);
};


// Visit a parse tree produced by LogoParser#bk.
LogoVisitor.prototype.visitBk = async function (ctx) {
    var value = await visitChild(1, ctx);
    if (isVisitorStopped()) {
        // If the visitor has been stopped, we return early, because the visitChild() calls may have returned `undefined`.
        return;
    }
    canvas.fd(-value);
};


// Visit a parse tree produced by LogoParser#rt.
LogoVisitor.prototype.visitRt = async function (ctx) {
    var value = await visitChild(1, ctx);
    if (isVisitorStopped()) {
        // If the visitor has been stopped, we return early, because the visitChild() calls may have returned `undefined`.
        return;
    }
    canvas.rt(value);
};


// Visit a parse tree produced by LogoParser#lt.
LogoVisitor.prototype.visitLt = async function (ctx) {
    var value = await visitChild(1, ctx);
    if (isVisitorStopped()) {
        // If the visitor has been stopped, we return early, because the visitChild() calls may have returned `undefined`.
        return;
    }
    canvas.lt(value);
};


// Visit a parse tree produced by LogoParser#cs.
LogoVisitor.prototype.visitCs = async function (ctx) {
    canvas.cs();
    canvas.ppt();
};

// Visit a parse tree produced by LogoParser#cs.
LogoVisitor.prototype.visitNext = async function (ctx) {
    canvas.cs();
    canvas.ppt();
    canvas.next();
};

// Visit a parse tree produced by LogoParser#cs.
LogoVisitor.prototype.visitRetry = async function (ctx) {
    canvas.cs();
    canvas.ppt();
};

// Visit a parse tree produced by LogoParser#cs.
LogoVisitor.prototype.visitLast = async function (ctx) {
    canvas.last();
    //TODO: implement last
};

//Visit a parse tree produced by LogoParser#ct.
LogoVisitor.prototype.visitCt = async function (ctx) {
    canvas.ct();
};


// Visit a parse tree produced by LogoParser#pu.
LogoVisitor.prototype.visitPu = async function (ctx) {
    canvas.pu();
};


// Visit a parse tree produced by LogoParser#pd.
LogoVisitor.prototype.visitPd = async function (ctx) {
    canvas.pd();
};


// Visit a parse tree produced by LogoParser#pe.
LogoVisitor.prototype.visitPe = async function (ctx) {
    canvas.pe();
};


// Visit a parse tree produced by LogoParser#ppt.
LogoVisitor.prototype.visitPpt = async function (ctx) {
    canvas.ppt();
};


// Visit a parse tree produced by LogoParser#ht.
LogoVisitor.prototype.visitHt = async function (ctx) {
    canvas.ht();
};


// Visit a parse tree produced by LogoParser#st.
LogoVisitor.prototype.visitSt = async function (ctx) {
    canvas.st();
};


// Visit a parse tree produced by LogoParser#setpc.
LogoVisitor.prototype.visitSetpc = async function (ctx) {
    var col = await visitChild(1, ctx);
    if (isVisitorStopped()) {
        // If the visitor has been stopped, we return early, because the visitChild() calls may have returned `undefined`.
        return;
    }
    canvas.setpencolor(col);
};


// Visit a parse tree produced by LogoParser#setsc.
LogoVisitor.prototype.visitSetsc = async function (ctx) {
    var col = await visitChild(1, ctx);
    if (isVisitorStopped()) {
        // If the visitor has been stopped, we return early, because the visitChild() calls may have returned `undefined`.
        return;
    }
    canvas.setscreencolor(col);
};


// Visit a parse tree produced by LogoParser#home.
LogoVisitor.prototype.visitHome = async function (ctx) {
    canvas.home();
};


// Visit a parse tree produced by LogoParser#stop.
LogoVisitor.prototype.visitStop = async function (ctx) {
    stopVisitor();
    return;
};


// Visit a parse tree produced by LogoParser#setxy.
LogoVisitor.prototype.visitSetxy = async function (ctx) {
    var valueY = await visitChild(2, ctx);
    var valueX = await visitChild(1, ctx);
    if (isVisitorStopped()) {
        // If the visitor has been stopped, we return early, because the visitChild() calls may have returned `undefined`.
        return;
    }
    canvas.setxy(valueX, valueY);
};


// Visit a parse tree produced by LogoParser#setx.
LogoVisitor.prototype.visitSetx = async function (ctx) {
    var value = await visitChild(1, ctx);
    if (isVisitorStopped()) {
        // If the visitor has been stopped, we return early, because the visitChild() calls may have returned `undefined`.
        return;
    }
    canvas.setx(value);
};


// Visit a parse tree produced by LogoParser#sety.
LogoVisitor.prototype.visitSety = async function (ctx) {
    var value = await visitChild(1, ctx);
    if (isVisitorStopped()) {
        // If the visitor has been stopped, we return early, because the visitChild() calls may have returned `undefined`.
        return;
    }
    canvas.sety(value);
};


// Visit a parse tree produced by LogoParser#random.
LogoVisitor.prototype.visitRandom = async function (ctx) {
    var value = await visitChild(1, ctx);
    return Math.floor(Math.random() * value);
};


// Visit a parse tree produced by LogoParser#sin.
LogoVisitor.prototype.visitSin = async function (ctx) {
    var value = await visitChild(1, ctx);
    return Math.sin(value);
};


// Visit a parse tree produced by LogoParser#cos.
LogoVisitor.prototype.visitCos = async function (ctx) {
    var value = await visitChild(1, ctx);
    return Math.cos(value);
};


// Visit a parse tree produced by LogoParser#tan.
LogoVisitor.prototype.visitTan = async function (ctx) {
	var value = await visitChild(1, ctx);
	
	// Check if tangens is undefined for value
	if (value - 0.5 * Math.PI % Math.PI === 0) {
		throw lang.getLang()['exception_invalid_argument_tan'];
	}

    return Math.tan(value);
};


// Visit a parse tree produced by LogoParser#arcsin.
LogoVisitor.prototype.visitArcsin = async function (ctx) {
    var value = await visitChild(1, ctx);
	if (value > 1 || value < -1) {
		throw lang.getLang()['exception_invalid_argument_asin'];
	}
    return Math.asin(value);
};


// Visit a parse tree produced by LogoParser#arccos.
LogoVisitor.prototype.visitArccos = async function (ctx) {
    var value = await visitChild(1, ctx);
    if (value > 1 || value < -1) {
		throw lang.getLang()['exception_invalid_argument_acos'];
	}
    return Math.acos(value);
};


// Visit a parse tree produced by LogoParser#arctan.
LogoVisitor.prototype.visitArctan = async function (ctx) {
    var value = await visitChild(1, ctx);
    // Domain of arctan is the set of all numbers, no catching needed
    return Math.atan(value);
};


// Visit a parse tree produced by LogoParser#abs.
LogoVisitor.prototype.visitAbs = async function (ctx) {
    var value = await visitChild(1, ctx);
    return Math.abs(value);
};


// Visit a parse tree produced by LogoParser#sqrt.
LogoVisitor.prototype.visitSqrt = async function (ctx) {
    var value = await visitChild(1, ctx);
    if (value < 0) {
		throw lang.getLang()['exception_sqrt_negative_number'];
	}
    return Math.sqrt(value);
};


// Visit a parse tree produced by LogoParser#mod.
LogoVisitor.prototype.visitMod = async function (ctx) {
    var value1 = await visitChild(1, ctx);
	var value2 = await visitChild(2, ctx);
	
	if (value2 === 0) {
		throw lang.getLang()['exception_invalid_argument_mod'];
	}
    return value1 % value2;
};

// Visit a parse tree produced by LogoParser#power.
LogoVisitor.prototype.visitPower = async function (ctx) {
    var value2 = await visitChild(1, ctx);
    var value1 = await visitChild(2, ctx);
    return Math.pow(value1, value2);
};


// Visit a parse tree produced by LogoParser#log10.
LogoVisitor.prototype.visitLog10 = async function (ctx) {
    var value = await visitChild(1, ctx);
    if (value < 0) {
		throw lang.getLang()['exception_log10_negative_number'];
	}
    return Math.log(value) / Math.LN10;
};


// Visit a parse tree produced by LogoParser#waite.
LogoVisitor.prototype.visitWaite = async function (ctx) {
    canvas.flush();

    if (!testingMode) {
		var time = await visitChild(1, ctx);

		// Check if time is negative
		if (time < 0) {
			throw lang.getLang()['exception_wait_negative_number'];
		}
		
        if (isVisitorStopped()) {
            // If the visitor has been stopped, we return early, because the visitChild() calls may have returned `undefined`.
            return;
		}
        
        // `wait 1` is one hundredth of a second
        var milliseconds = time * 10;
        // We wait in intervals, because otherwise we can't interrupt the visitor.
        var steps = Math.floor(milliseconds / WAIT_INTERVAL_MS);
        var rest = milliseconds - steps * WAIT_INTERVAL_MS;
        for (var i = 0; i < steps; i++) {
            await waitForABit(WAIT_INTERVAL_MS);
            if (isVisitorStopped()) {
                return;
            }
        }
        await waitForABit(rest);
        canvas.wait();
        return wait;
    } else {
        //if we are running test suite: do not pause but instead take a snapshop and continue
        //TODO: take snapshot

        return 0;
    }

};

// Visit a parse tree produced by LogoParser#wash.
LogoVisitor.prototype.visitWash = async function (ctx) {
    canvas.wash();
};


// Visit a parse tree produced by LogoParser#setpw.
LogoVisitor.prototype.visitSetpw = async function (ctx) {
    var width = await visitChild(1, ctx);
	
	// Check if width is larger than 0
	if (width < 0) {
		throw lang.getLang()['exception_setpw_negative_number'];
	}

    if (isVisitorStopped()) {
        // If the visitor has been stopped, we return early, because the visitChild() calls may have returned `undefined`.
        return;
    }
    canvas.setpw(width);
};


// Visit a parse tree produced by LogoParser#circle.
LogoVisitor.prototype.visitCircle = async function (ctx) {
    var radius = await visitChild(1, ctx);
	if (radius < 0) {
		throw lang.getLang()['exception_circle_negative_number'];
	}
	
    if (isVisitorStopped()) {
        // If the visitor has been stopped, we return early, because the visitChild() calls may have returned `undefined`.
        return;
    }
    canvas.circle(radius);
};


// Visit a parse tree produced by LogoParser#setheading.
LogoVisitor.prototype.visitSetheading = async function (ctx) {
    var value = await visitChild(1, ctx);
    if (isVisitorStopped()) {
        // If the visitor has been stopped, we return early, because the visitChild() calls may have returned `undefined`.
        return;
    }
    canvas.setheading(value);
};


// Visit a parse tree produced by LogoParser#number.
LogoVisitor.prototype.visitNumber = async function (ctx) {
    var value;

    //if it has three children it is a rational number
    if (ctx.children.length === 3) {
        value = parseFloat(ctx.getChild(0)) + parseFloat("0." + ctx.getChild(2));;
    } else {
        //pi, e or a natural number
        value = parseFloat(ctx.getChild(0));
    }

    if (!isNaN(value)) {//not pi or e
        return value;
    } else {
        return await visitChild(0, ctx);
    }
};


// Visit a parse tree produced by LogoParser#pie.
LogoVisitor.prototype.visitPie = async function (ctx) {
    return Math.PI;
};


// Visit a parse tree produced by LogoParser#ee.
LogoVisitor.prototype.visitEe = async function (ctx) {
    return Math.E;
};

// Visit a parse tree produced by LogoParser#comment.
LogoVisitor.prototype.visitComment = async function (ctx) {

};

// Visit a parse tree produced by LogoParser#eol.
LogoVisitor.prototype.visitEol = function (ctx) {

};

exports.LogoVisitor = LogoVisitor;
LogoVisitor.prototype.visitEnd = function (ctx) {

};

LogoVisitor.prototype.visitUnitTest = function (ctx) {
    // unit test

    var testCases = new Array();

    testCases = [
        { name: "Ok1", code: "to bla \n fd 100 \n end", expectedResult: [] },
        { name: "Ok2", code: "to bla \n \n \n bk mod 7 5 fd mod 3 5 \n \n \n \n end", expectedResult: [] },
        { name: "Ok3", code: "to bla \n \n \n print [fd] \n \n end", expectedResult: [] },
        { name: "Ok6", code: "to bla \n \n repeat 4 [repeat 6 [fd 100]]\n \n end", expectedResult: [] },

        { name: "ManyTos1", code: "to to bla \n end", expectedResult: [{ line: 0, msg: "manyTos" }] },
        { name: "ManyTos2", code: "to to \n \n bla \n \n end", expectedResult: [{ line: 0, msg: "manyTos" }] },
        { name: "ManyTos3", code: "to to to to \n \n bla \n \n end", expectedResult: [{ line: 0, msg: "manyTos" }] },
        { name: "ManyTos4", code: "to to bla \n end end", expectedResult: [{ line: 0, msg: "manyTos" }, { line: 1, msg: "manyEnds" }] },
        { name: "ManyTos5", code: "to to \n bla \n \n end end", expectedResult: [{ line: 0, msg: "manyTos" }, { line: 3, msg: "manyEnds" }] },
        { name: "ManyTos6", code: "to to \n \n bla \n fd 100 \n \n end \n \n end", expectedResult: [{ line: 0, msg: "manyTos" }, { line: 7, msg: "manyEnds" }] },

        { name: "ManyEnds1", code: "to bla \n end end", expectedResult: [{ line: 1, msg: "manyEnds" }] },
        { name: "ManyEnds2", code: "to bla \n fd 100 \n \n \n end end", expectedResult: [{ line: 4, msg: "manyEnds" }] },
        { name: "ManyEnds3", code: "to bla \n fd 100 \n \n \n end end \n end \n \n end", expectedResult: [{ line: 4, msg: "manyEnds" }, { line: 5, msg: "manyEnds" }, { line: 7, msg: "manyEnds" }] },
        { name: "ManyEnds4", code: "to bla \n fd 100 \n \n \n end end \n end \n \n end \n \n", expectedResult: [{ line: 4, msg: "manyEnds" }, { line: 5, msg: "manyEnds" }, { line: 7, msg: "manyEnds" }] },

        { name: "ParamsNoColon1", code: "to bla :a b :c \n end", expectedResult: [{ line: 0, msg: "paramsNoColon" }] },
        { name: "ParamsNoColon2", code: "to bla :a b c \n end", expectedResult: [{ line: 0, msg: "paramsNoColon" }] },
        { name: "ParamsNoColon3", code: "to bla :a :b c \n fd 100 \n end", expectedResult: [{ line: 0, msg: "paramsNoColon" }] },
        { name: "ParamsNoColon4", code: "to bla :a b \n end", expectedResult: [{ line: 0, msg: "paramsNoColon" }] },
        { name: "ParamsNoColon5", code: "to bla :a b :c d \n end", expectedResult: [{ line: 0, msg: "paramsNoColon" }] },
        { name: "ParamsNoColon6", code: "to bla :a b c d \n end", expectedResult: [{ line: 0, msg: "paramsNoColon" }] },
        { name: "ParamsNoColon7", code: "to bla :a :b c d \n end", expectedResult: [{ line: 0, msg: "paramsNoColon" }] },
        { name: "ParamsNoColon8", code: "to bla :a b :c :d \n end", expectedResult: [{ line: 0, msg: "paramsNoColon" }] },
        { name: "ParamsNoColon9", code: "to bla :a :b :c d \n end", expectedResult: [{ line: 0, msg: "paramsNoColon" }] },
        { name: "ParamsNoColon10", code: "to bla :a b c :d \n end", expectedResult: [{ line: 0, msg: "paramsNoColon" }] },
        { name: "ParamsNoColon11", code: "to bla :a b :c d e \n end", expectedResult: [{ line: 0, msg: "paramsNoColon" }] },
        { name: "MisspelledEnd1", code: "to bla :gr \n \n ned", expectedResult: [{ line: 2, msg: "misspelledEnd" }] },

        { name: "MissingTo1", code: "bla :a :b :c \n fd 100 \n end", expectedResult: [{ line: 0, msg: "missingTo" }] },
        { name: "MissingTo2", code: "bla :a b :c \n fd 100 \n end", expectedResult: [{ line: 0, msg: "missingTo" }] },
        { name: "MissingTo3", code: "bla :a :b :c \n \n \n fd 100 \n end", expectedResult: [{ line: 0, msg: "missingTo" }] },
        { name: "MissingTo4", code: "bla :a :b c \n fd 100 \n end", expectedResult: [{ line: 0, msg: "missingTo" }] },
        { name: "MissingTo5", code: "bla :a :b :c \n fd 100 \n end end", expectedResult: [{ line: 0, msg: "missingTo" }, { line: 2, msg: "manyEnds" }] },

        { name: "MissingEnd1", code: "to bla :a :b :c \n fd 100 \n ", expectedResult: [{ line: 1, msg: "missingEnd" }] },
        { name: "MissingEnd2", code: "to bla :a :b :c ", expectedResult: [{ line: 0, msg: "missingEnd" }] },
        { name: "MissingEnd3", code: "to bla :a :b :c \n \n ", expectedResult: [{ line: 0, msg: "missingEnd" }] },
        { name: "MissingEnd4", code: "to bla :a :b :c \n \n \n fd 100 \n ", expectedResult: [{ line: 3, msg: "missingEnd" }] },

        { name: "NoName1", code: "to :a :b :c \n fd 100 \n end", expectedResult: [{ line: 0, msg: "noName" }] },
        { name: "NoName2", code: "to :a b :c \n fd 100 \n end", expectedResult: [{ line: 0, msg: "noName" }] },
        { name: "NoName3", code: "to \n fd 100 \n end", expectedResult: [{ line: 0, msg: "noName" }] },
        { name: "NoName4", code: "to \n end", expectedResult: [{ line: 0, msg: "noName" }] },
        { name: "NoName5", code: "to \n end end", expectedResult: [{ line: 0, msg: "noName" }, { line: 1, msg: "manyEnds" }] },


        { name: "NameTo1", code: "to to :a :b :c \n fd 100 \n end", expectedResult: [{ line: 0, msg: "nameTO" }] },
        { name: "NameTo2", code: "to to :a b :c \n fd 100 \n end", expectedResult: [{ line: 0, msg: "nameTO" }] },
        { name: "NameTo3", code: "to to :a b :c \n fd 100 \n end end", expectedResult: [{ line: 0, msg: "nameTO" }, { line: 2, msg: "manyEnds" }] },


        { name: "NameEnd1", code: "to end :a :b :c \n fd 100 \n end", expectedResult: [{ line: 0, msg: "nameEND" }] },
        { name: "NameEnd2", code: "to end :a b :c \n fd 100 \n end", expectedResult: [{ line: 0, msg: "nameEND" }] },
        { name: "NameEnd3", code: "to end :a :b :c \n fd 100 \n end \n end", expectedResult: [{ line: 0, msg: "nameEND" }, { line: 3, msg: "manyEnds" }] },


        { name: "NameCmd1", code: "to fd :a :b :c \n fd 100 \n end", expectedResult: [{ line: 0, msg: "nameCMD" }] },
        { name: "NameCmd2", code: "to fd :a b :c \n fd 100 \n end", expectedResult: [{ line: 0, msg: "nameCMD" }] },
        { name: "NameCmd3", code: "to fd :a :b :c \n fd 100 \n end end", expectedResult: [{ line: 0, msg: "nameCMD" }, { line: 2, msg: "manyEnds" }] },

        { name: "NoToNoName1", code: ":a fd 100 end", expectedResult: [{ line: 0, msg: "noToNoName" }] },
        { name: "NoToNoName2", code: ":a fd 100 \n end", expectedResult: [{ line: 0, msg: "noToNoName" }] },

        { name: "NoToNoNameToo1", code: "fd 100 end", expectedResult: [{ line: 0, msg: "noToNoName" }] },
        { name: "NoToNoNameToo2", code: "fd 100 \n end", expectedResult: [{ line: 0, msg: "noToNoName" }] },

        { name: "NameFunc1", code: "to sin :a :b :c \n fd 100 \n end", expectedResult: [{ line: 0, msg: "nameFUNC" }] },
        { name: "NameFunc2", code: "to sin :a b :c \n fd 100 \n end", expectedResult: [{ line: 0, msg: "nameFUNC" }] },
        { name: "NameFunc3", code: "to sin :a :b :c \n fd 100 \n end end", expectedResult: [{ line: 0, msg: "nameFUNC" }, { line: 2, msg: "manyEnds" }] },

        { name: "ParamDeclsNotOk1", code: "to abc :a : b :c \n fd 100 \n end", expectedResult: [{ line: 0, msg: "paramDeclsNotOk" }] },
        { name: "ParamDeclsNotOk2", code: "to abc : a :b :c \n fd 100 \n end", expectedResult: [{ line: 0, msg: "paramDeclsNotOk" }] },
        { name: "ParamDeclsNotOk3", code: "to abc : a \n fd 100 \n end", expectedResult: [{ line: 0, msg: "paramDeclsNotOk" }] },


        { name: "noEOL1", code: "to abc :a :b :c fd 100 \n end", expectedResult: [{ line: 0, msg: "noEOL" }] },
        { name: "noEOL2", code: "to abc :a :b :c fd 100 end", expectedResult: [{ line: 0, msg: "noEOL" }] },
        { name: "noEOL3", code: "to abc fd 100 fd 100 bk 50 \n \n \n \n end", expectedResult: [{ line: 0, msg: "noEOL" }] },
        { name: "noEOL4", code: "to abc fd 100 \n \n end", expectedResult: [{ line: 0, msg: "noEOL" }] },
        { name: "noEOL5", code: "to abc fd 100 \n end end", expectedResult: [{ line: 0, msg: "noEOL" }, { line: 1, msg: "manyEnds" }] },
        { name: "noEOL6", code: "to abc fd 100 \n \n end \n end \n \n end", expectedResult: [{ line: 0, msg: "noEOL" }, { line: 3, msg: "manyEnds" }, { line: 5, msg: "manyEnds" }] },

        { name: "noEOLbeforeEND1", code: "to abc :a :b :c \n fd 100 end", expectedResult: [{ line: 1, msg: "noEOLbeforeEND" }] },
        { name: "noEOLbeforeEND2", code: "to abc :a :b :c \n fd 100 repeat 4 end", expectedResult: [{ line: 1, msg: "noEOLbeforeEND" }, { line: 1, msg: "repeatMissingBlock" }] },
        { name: "noEOLbeforeEND3", code: "to abc :a :b :c end", expectedResult: [{ line: 0, msg: "noEOLbeforeEND" }] },

        { name: "methodNameWhitespace1", code: "to abc a :b :c \n fd 100 \n end", expectedResult: [{ line: 0, msg: "methodNameWhitespace" }, { line: 0, msg: "paramsNoColon" }] },
        { name: "methodNameWhitespace2", code: "to abc a :b :c \n fd 100 \n end end", expectedResult: [{ line: 0, msg: "methodNameWhitespace" }, { line: 0, msg: "paramsNoColon" }, { line: 2, msg: "manyEnds" }] },
        { name: "methodNameWhitespace3", code: "to abc a aa :b :c \n fd 100 \n end", expectedResult: [{ line: 0, msg: "methodNameWhitespace" }, { line: 0, msg: "paramsNoColon" }] },
        { name: "methodNameWhitespace4", code: "to abc a aa :b :c \n fd 100 \n \n end end", expectedResult: [{ line: 0, msg: "methodNameWhitespace" }, { line: 0, msg: "paramsNoColon" }, { line: 3, msg: "manyEnds" }] },
        { name: "methodNameWhitespace5", code: "to abc a aa :b :c \n fd 100 \n \n end end \n end", expectedResult: [{ line: 0, msg: "methodNameWhitespace" }, { line: 0, msg: "paramsNoColon" }, { line: 3, msg: "manyEnds" }, { line: 4, msg: "manyEnds" }] },

        { name: "MakeLitNotOk1", code: "to bla \n make \" s 5 \n end", expectedResult: [{ line: 1, msg: "makeLitNotOk" }] },

        { name: "RepeatMissingExpr1", code: "to bla \n repeat [fd 100] \n end", expectedResult: [{ line: 1, msg: "repeatMissingExpr" }] },

        { name: "RepeatMissingBlock1", code: "to bla \n repeat 5 \n end", expectedResult: [{ line: 1, msg: "repeatMissingBlock" }] },

        { name: "RepeatNoArg1", code: "to bla \n repeat fd 100 \n end", expectedResult: [{ line: 1, msg: "repeatNoArg" }] },

        { name: "BlockWrongBrackets1", code: "to bla \n repeat 4 (fd 100) \n end", expectedResult: [{ line: 1, msg: "blockWrongBrackets" }] },

        { name: "DerefNotOk1", code: "to bla :s \n fd : s \n end", expectedResult: [{ line: 1, msg: "derefNotOk" }] },

        { name: "ParamDeclNoName1", code: "to bla : :a \n fd 100 \n end", expectedResult: [{ line: 0, msg: "paramDeclNoName" }] },
        { name: "ParamDeclNoName2", code: "to bla :a : :b \n fd 100 \n end", expectedResult: [{ line: 0, msg: "paramDeclNoName" }] },
        { name: "ParamDeclNoName3", code: "to bla :a : \n fd 100 \n end", expectedResult: [{ line: 0, msg: "paramDeclNoName" }] },

        { name: "WhileMissingBlock1", code: "to bla \n while [3<2] \n end", expectedResult: [{ line: 1, msg: "whileMissingBlock" }] },

        { name: "WhileManyBlocks1", code: "to bla \n while [3<2] [] [] \n end", expectedResult: [{ line: 1, msg: "whileManyBlocks" }] },

        { name: "IfNoBlock1", code: "to bla \n if 3<2 \n end", expectedResult: [{ line: 1, msg: "ifNoBlock" }] },

        { name: "IfManyBlocks1", code: "to bla \n if 3<2 [] [] [] \n end", expectedResult: [{ line: 1, msg: "ifManyBlocks" }] },

        { name: "IfBrackets1", code: "to bla \n if [3<2] [] \n end", expectedResult: [{ line: 1, msg: "ifBrackets" }] },
        { name: "IfBrackets2", code: "to bla \n if [3<2] [] [] \n end", expectedResult: [{ line: 1, msg: "ifBrackets" }] },

        { name: "PrintNoArg1", code: "to bla \n print fd 100 \n end", expectedResult: [{ line: 1, msg: "printNoArg" }] },

        { name: "PrintManyArgs1", code: "to bla \n print 5 7 \n end", expectedResult: [{ line: 1, msg: "printManyArgs" }] },
        { name: "PrintManyArgs2", code: "to bla \n print 5 [blablablala] \n end", expectedResult: [{ line: 1, msg: "printManyArgs" }] },

        { name: "ColorNameMisspelled1", code: "to bla \n setpc ye \n end", expectedResult: [{ line: 1, msg: "colornameMisspelled" }] },

        { name: "MisspelledTo1", code: "too bla \n fd 100 \n end", expectedResult: [{ line: 0, msg: "maybeTo" }] },
        { name: "MisspelledTo2", code: "too bla \n fd 100 \n end end", expectedResult: [{ line: 0, msg: "maybeTo" }, { line: 2, msg: "manyEnds" }] },
        { name: "MisspelledTo3", code: "too bla \n fd 100 \n end end \n end", expectedResult: [{ line: 0, msg: "maybeTo" }, { line: 2, msg: "manyEnds" }, { line: 3, msg: "manyEnds" }] },

        { name: "VariableNotDeclared1", code: "to bla \n fd :c \n end", expectedResult: [{ line: 1, msg: "variableNotDeclared" + "c" }] },

        { name: "DoubleDeclaration1", code: "to bla \n fd 100 \n end \n \n \n to bla \n end end", expectedResult: [{ line: 5, msg: "doubleDeclaration" }, { line: 6, msg: "manyEnds" }] },
        { name: "DoubleDeclaration2", code: "to bla \n fd 100 \n end \n \n \n to bla \n end \n end", expectedResult: [{ line: 5, msg: "doubleDeclaration" }, { line: 7, msg: "manyEnds" }] },

        { name: "EolAfterTo1", code: "to \n bla \n fd 100 \n end", expectedResult: [{ line: 0, msg: "eolAfterTo" }] },
        { name: "EolAfterTo2", code: "to \n \n \n bla \n fd 100 \n end", expectedResult: [{ line: 0, msg: "eolAfterTo" }] },
        { name: "EolAfterTo3", code: "to \n bla \n fd 100 end", expectedResult: [{ line: 0, msg: "eolAfterTo" }] },
        { name: "EolAfterTo4", code: "to \n bla \n fd 100", expectedResult: [{ line: 0, msg: "eolAfterTo" }, { line: 2, msg: "missingEnd" }] },

        { name: "PrintOk1", code: "to bla \n print [print] \n end", expectedResult: [] },

        { name: "EolBeforeParams1", code: "to bla \n \n :a \n print [fkdjkla] \n \n \n end", expectedResult: [{ line: 2, msg: "eolBeforeParams" }] },
        { name: "EolBeforeParams2", code: "to bla \n \n :a fd 100 \n print [fkdjkla] \n \n \n end", expectedResult: [{ line: 2, msg: "eolBeforeParams" }] },
        { name: "EolBeforeParams3", code: "to bla \n \n :a fd 100 \n print [fkdjkla] \n \n \n", expectedResult: [{ line: 2, msg: "eolBeforeParams" }, { line: 3, msg: "missingEnd" }] },

        { name: "DauerTest1", code: "to vieleckeab3 :eck :seite :farbe \n if :eck > 2 [setpc :farbe repeat :eck [fd :seite rt 360/:eck]] \n end", expectedResult: [] },
        { name: "DauerTest2", code: "to zweiquadrate :seite1 :seite2 \n repeat 7 [fd :seite1 rt 90] rt 90 repeat 4 [fd :seite2 rt 90] \n end", expectedResult: [] },
        { name: "DauerTest3", code: "to bla \n repeat 4 [repeat 4 []] \n \n \n end", expectedResult: [] },
        { name: "DauerTest4", code: "to bla \n repeat 5 [repeat 4 [repeat 6 []]] \n \n \n end", expectedResult: [] },
        { name: "DauerTest5", code: "to d29 :anz :gr \n if :anz > 2[repeat :anz[]] \n end", expectedResult: [] },
        { name: "DauerTest6", code: "to d29 :anz :gr \n if :anz > 2[repeat :anz[fd :gr rt 360/:anz]] \n end", expectedResult: [] },
        { name: "DauerTest7", code: "to d29 :anz :gr \n if :anz > 2[if :anz*:gr < 1600 [repeat :anz[fd :gr rt 360/:anz]]] \n end", expectedResult: [] },
        { name: "DauerTest8", code: "to d29 :anz :gr \n if :anz > 2[ \n if :anz*:gr < 1600 [ \n repeat :anz[fd :gr rt 360/:anz] \n ] \n ] \n \n end", expectedResult: [] }
    ];

    var errorCounter = 0;

    console.time("total time for tests:");
    for (let test of testCases) {
        console.time(test.name);
        let editor = inputComponent.readEditor(test.code, 0);

        if (editor == null) {
            console.error(test.name + " PARSEFAILURE");
            errorCounter++;
            continue;
        }
        if (editor.errors.length !== test.expectedResult.length) {
            //not the same number of errors, test failed
            console.error(test.name + " failed");
            console.warn(test.code);
            errorCounter++;
        } else {
            if (editor.errors.length === 0) {
                //test succeeded, there are no errors
                console.log(test.name + " succeeded");
            } else {
                var i;
                for (i = 0; i < editor.errors.length; i++) {
                    if ((editor.errors[i].line !== test.expectedResult[i].line) || (editor.errors[i].msg !== test.expectedResult[i].msg)) {
                        console.error(test.name + " failed");
                        console.warn(test.code);
                        errorCounter++;
                    } else {
                        console.log(test.name + " succeeded");
                    }
                }
            }
        }
        console.timeEnd(test.name);
    }
    let numberOfTestCases = testCases.length;
    if (errorCounter === 0) {
        console.log("ALL " + numberOfTestCases.toString() + " TESTS SUCCEEDED");
    } else {
        console.error(errorCounter.toString() + " out of " + numberOfTestCases.toString() + " tests failed.");
    }
    console.timeEnd("total time for tests:");
    inputComponent.errorIndizes = new Array();

};

function getBase64Image(img) {
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    var dataURL = canvas.toDataURL("image/png");
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
}

var testcases = [
    { identifier: "Kapitel1_Seite05_Beispiel1", input: "forward 100 right 90 forward 100", editor: "" },
    { identifier: "Kapitel1_Seite05_Aufgabe1", input: "right 90 forward 100", editor: "" },
    { identifier: "Kapitel1_Seite06_Aufgabe2", input: "fd 200 rt 90 fd 100 rt 180 fd 200 ", editor: "" },
    { identifier: "Kapitel1_Seite07_Aufgabe3", input: "fd 200 rt 90 fd 100 rt 180 fd 200 rt 180 fd 100 rt 90 fd 200 rt 180", editor: "" },
    { identifier: "Kapitel1_Seite07_Aufgabe4", input: "fd 100 rt 90 fd 200 rt 90 fd 100", editor: "" },
    { identifier: "Kapitel1_Seite07_Aufgabe5a", input: "fd 200 rt 90 fd 200 rt 90 fd 200 rt 90 fd 200 rt 90", editor: "" },
    { identifier: "Kapitel1_Seite07_Aufgabe5b", input: "rt 90 fd 100 rt 270 fd 100 rt 90 fd 100 rt 90 fd 100 rt 270 fd 100 rt 270 fd 200 rt 90 fd 100 rt 90 fd 200 rt 270 fd 100", editor: "" },
    { identifier: "Kapitel1_Seite08_Aufgabe6a", input: "rt 90 fd 200 rt 90 fd 200 rt 90 fd 200 rt 90 fd 200", editor: "" },
    { identifier: "Kapitel1_Seite08_Aufgabe6b", input: "lt 90 bk 200 lt 90 bk 200 lt 90 bk 200 rt 270 bk 200", editor: "" },
    { identifier: "Kapitel1_Seite08_Aufgabe7a", input: "fd 300 rt 270 fd 150 rt 90 fd 100 rt 90 fd 400 rt 90 fd 100 rt 90 fd 150 rt 270 fd 300 rt 90 fd 100", editor: "" },
    { identifier: "Kapitel1_Seite08_Aufgabe7b", input: "fd 400 rt 90 fd 350 rt 90 fd 300 rt 90 fd 250 rt 90 fd 200 rt 90 fd 150 rt 90 fd 100 rt 90 fd 50", editor: "" },
    { identifier: "Kapitel1_Seite09_Aufgabe8a", input: "lt 90 bk 100 lt 90 bk 300 lt 270 bk 150 lt 90 bk 100 lt 90 bk 400 lt 90 bk 100 lt 90 bk 150 lt 270 bk 300", editor: "" },
    { identifier: "Kapitel1_Seite09_Aufgabe8b", input: "lt 90 bk 50 lt 90 bk 100 lt 90 bk 150 lt 90 bk 200 lt 90 bk 250 lt 90 bk 300 lt 90 bk 350 lt 90 bk 400", editor: "" },
    { identifier: "Kapitel1_Seite09_Aufgabe9a", input: "fd 400 rt 90 fd 400 rt 90 fd 400 rt 90 fd 400 bk 200 rt 90 fd 400 bk 200 rt 90 fd 200 bk 400", editor: "" },
    { identifier: "Kapitel1_Seite09_Aufgabe9b", input: "fd 200 bk 200 rt 90 fd 200 bk 200 rt 90 fd 200 bk 200 rt 90 fd 200", editor: "" },
    { identifier: "Kapitel1_Seite10_Beispiel2", input: "setpc red fd 100 rt 90 setpc blue fd 100 rt 90 setpc yellow fd 100 rt 90 setpc green fd 100 rt 90", editor: "" },
    { identifier: "Kapitel1_Seite12_Aufgabe10", input: "setpc red fd 200 lt 90 fd 200 rt 90 fd 100 rt 90 fd 200 lt 90 fd 200 rt 90 fd 100 rt 90 fd 200 lt 90 fd 200 rt 90 fd 100 rt 90 fd 200 lt 90 fd 200 rt 90 fd 100 rt 90", editor: "" },
    { identifier: "Kapitel1_Seite12_Aufgabe11", input: "setpc blue fd 300 rt 120 fd 300 rt 120 fd 300 rt 120", editor: "" },
    { identifier: "Kapitel1_Seite13_Aufgabe12", input: "fd 100 rt 120 fd 100 rt 120 fd 100 rt 120 setpc white fd 100 rt 120 fd 100 rt 120 fd 100 rt 120", editor: "" },
    { identifier: "Kapitel1_Seite13_Aufgabe13a", input: "setpc black rt 90 fd 150 setpc white fd 100 setpc black fd 150 setpc white fd 100 setpc black fd 150 setpc white fd 100 setpc black fd 150", editor: "" },
    { identifier: "Kapitel1_Seite13_Aufgabe13b", input: "setpc black fd 100 rt 90 fd 100 rt 90 fd 100 rt 90 fd 100 bk 100 setpc white bk 100 rt 90 setpc purple fd 100 rt 90 fd 100 rt 90 fd 100 rt 90 fd 100 bk 100 setpc white bk 100 rt 90 setpc black fd 100 rt 90 fd 100 rt 90 fd 100 rt 90 fd 100", editor: "" },
    { identifier: "Kapitel1_Seite13_Aufgabe13c", input: "setpc darkblue rt 30 fd 100 rt 120 fd 100 rt 120 fd 100 bk 100 setpc white bk 100 rt 120 setpc yellow fd 100 rt 120 fd 100 rt 120 fd 100 bk 100 setpc white bk 100 rt 120 setpc red fd 100 rt 120 fd 100 rt 120 fd 100", editor: "" },
    { identifier: "Kapitel1_Seite15_Kontrollaufgabe1", input: "fd 100 rt 90 fd 100 rt 90 fd 100 rt 90 fd 100 rt 90 fd 100", editor: "" },
    { identifier: "Kapitel1_Seite15_Kontrollaufgabe2", input: "setpc red fd 100 rt 90 fd 150 rt 90 fd 100 rt 90 fd 150 rt 180", editor: "" },
    { identifier: "Kapitel1_Seite15_Kontrollaufgabe3a", input: "rt 30 fd 100 rt 120 fd 100 lt 120 fd 100 rt 120 fd 100 lt 120 fd 100 rt 120 fd 100", editor: "" },
    { identifier: "Kapitel1_Seite15_Kontrollaufgabe3b", input: "rt 90 fd 100 lt 90 fd 100 rt 90 fd 100 rt 90 fd 100 lt 90 fd 100 lt 90 fd 100 rt 90 fd 100 rt 90 fd 100 lt 90 fd 100 lt 90 fd 100 rt 90 fd 100 rt 90 fd 100 lt 90 fd 100", editor: "" },
    { identifier: "Kapitel1_Seite15_Kontrollaufgabe3c", input: "setpc white rt 90 bk 300 lt 90 setpc black rt 90 fd 100 lt 90 fd 100 rt 90 fd 100 lt 90 fd 100 rt 90 fd 100 rt 90 fd 100 lt 90 fd 100 rt 90 fd 100 lt 90 fd 100", editor: "" },
    { identifier: "Kapitel1_Seite15_Kontrollaufgabe3d", input: "setpc white rt 90 bk 200 setpc black fd 100 setpc white fd 100 setpc black fd 100 setpc white fd 100 setpc black fd 100 setpc white rt 90 fd 100 lt 90 bk 400 setpc black fd 100 setpc white fd 100 setpc black fd 100 setpc white fd 100 setpc black fd 100", editor: "" },
    { identifier: "Kapitel1_Seite15_Kontrollaufgabe3e", input: "setpc black fd 400 rt 90 fd 500 rt 90 fd 400 rt 90 fd 500 rt 90 fd 300 lt 90 setpc red fd 20 rt 90 fd 50 rt 90 fd 20 setpc white fd 500 setpc red fd 20 rt 90 fd 50 rt 90 fd 20 setpc white fd 100 setpc blue fd 50 rt 90 fd 50 rt 90 fd 50 rt 90 fd 50 rt 90 fd 50 setpc white fd 200 setpc blue fd 50 rt 90 fd 50 rt 90 fd 50 rt 90 fd 50 rt 90 fd 50 setpc white fd 50 lt 90 fd 200 setpc blue fd 20 lt 90 fd 400 lt 90 fd 20 setpc white fd 50 lt 90 fd 150 setpc brown fd 50 rt 90 fd 50 rt 90 fd 50 lt 90 fd 50 setpc white fd 120 rt 90 setpc white fd 50 setpc brown fd 70 bk 70 setpc white bk 200 setpc brown bk 70", editor: "" },
    { identifier: "Kapitel1_Seite15_Kontrollaufgabe4", input: "fd 200 rt 90 fd 180 rt 90 fd 160 rt 90 fd 140 rt 90 fd 120 rt 90 fd 100 rt 90 fd 80 rt 90 fd 60 rt 90 fd 40 rt 90 fd 20 rt 90", editor: "" },
    { identifier: "Kapitel2_Seite17_Beispiel1", input: "repeat 4[fd 200 rt 90]", editor: "" },
    { identifier: "Kapitel2_Seite17_Aufgabe1", input: "repeat 4[fd 300 rt 90]", editor: "" },
    { identifier: "Kapitel2_Seite17_Aufgabe2", input: "repeat 3[fd 300 rt 120]", editor: "" },
    { identifier: "Kapitel2_Seite18_Aufgabe3a", input: "repeat 8[fd 100 rt 45]", editor: "" },
    { identifier: "Kapitel2_Seite18_Aufgabe3b", input: "repeat 16[fd 100 rt 45 wait 50]", editor: "" },
    { identifier: "Kapitel2_Seite18_Aufgabe3c", input: "repeat 8[fd 150 rt 45]", editor: "" },
    { identifier: "Kapitel2_Seite18_Beispiel2a", input: "setpc darkgreen rt 90 fd 100 rt 90 fd 50", editor: "" },
    { identifier: "Kapitel2_Seite18_Beispiel2b", input: "setpc darkgreen rt 90 repeat 5[fd 100 rt 90 fd 50 lt 90]", editor: "" },
    { identifier: "Kapitel2_Seite19_Aufgabe4a", input: "repeat 6[fd 50 rt 90 fd 50 lt 90]", editor: "" },
    { identifier: "Kapitel2_Seite19_Aufgabe4b", input: "rt 90 setpc white bk 250 setpc black repeat 6 [fd 70 rt 90 fd 40 lt 90]", editor: "" },
    { identifier: "Kapitel2_Seite20_Aufgabe5a", input: "repeat 8[fd 200 bk 200 rt 45]", editor: "" },
    { identifier: "Kapitel2_Seite20_Aufgabe5b", input: "repeat 4[fd 200 bk 400 fd 200 rt 45]", editor: "" },
    { identifier: "Kapitel2_Seite20_Aufgabe5c", input: "repeat 12[fd 200 bk 200 rt 30] ", editor: "" },
    { identifier: "Kapitel2_Seite21_Aufgabe6a", input: "rt 90 repeat 6 [setpc red fd 50 setpc black lt 90 fd 50 rt 90 fd 50 rt 90 fd 50 lt 90]", editor: "" },
    { identifier: "Kapitel2_Seite21_Aufgabe6b", input: "rt 90 repeat 6[setpc darkblue fd 70 setpc white fd 50]", editor: "" },
    { identifier: "Kapitel2_Seite21_Aufgabe6c", input: "repeat 6 [setpc green repeat 5 [fd 20 bk 20 rt 90] fd 20 setpc white fd 60 lt 90]", editor: "" },
    { identifier: "Kapitel2_Seite21_Aufgabe6d", input: "repeat 10[setpc black fd 100 bk 100 setpc white rt 90 fd 50 lt 90]", editor: "" },
    { identifier: "Kapitel2_Seite22_Beispiel3", input: "repeat 10[fd 100 rt 36]", editor: "" },
    { identifier: "Kapitel2_Seite23_Aufgabe7a", input: "repeat 7[fd 200 rt 360/7]", editor: "" },
    { identifier: "Kapitel2_Seite23_Aufgabe7b", input: "repeat 6[fd 150 rt 60]", editor: "" },
    { identifier: "Kapitel2_Seite23_Aufgabe7c", input: "repeat 14[fd 100 rt 360/14]", editor: "" },
    { identifier: "Kapitel2_Seite23_Aufgabe7d", input: "repeat 16[fd 60 rt 360/16]", editor: "" },
    { identifier: "Kapitel2_Seite23_Aufgabe7e", input: "repeat 3[fd 300 rt 360/3]", editor: "" },
    { identifier: "Kapitel2_Seite23_Aufgabe7f", input: "repeat 24[fd 30 rt 360/24]", editor: "" },
    { identifier: "Kapitel2_Seite23_Aufgabe8a", input: "repeat 6[fd 1200/6 rt 360/6]", editor: "" },
    { identifier: "Kapitel2_Seite23_Aufgabe8b", input: "repeat 8[fd 1500/8 rt 360/8] ", editor: "" },
    { identifier: "Kapitel2_Seite23_Beispiel4", input: "repeat 360[fd 3 rt 1] repeat 180[fd 7 rt 2] repeat 200[fd 4 rt 360/200]", editor: "" },
    { identifier: "Kapitel2_Seite24_Aufgabe9a", input: "repeat 360[fd 1 rt 1]", editor: "" },
    { identifier: "Kapitel2_Seite24_Aufgabe9b", input: "repeat 360[fd 1440/360 rt 1]", editor: "" },
    { identifier: "Kapitel2_Seite24_Aufgabe9c", input: "repeat 360[fd 2000/360 rt 1]", editor: "" },
    { identifier: "Kapitel2_Seite24_Aufgabe10", input: "setpc red repeat 180[fd 3 rt 1] lt 180 setpc yellow repeat 180[fd 3 rt 1]", editor: "" },
    { identifier: "Kapitel2_Seite24_Beispiel5", input: "setpc green repeat 2[repeat 120[fd 3 rt 1] rt 60]", editor: "" },
    { identifier: "Kapitel2_Seite25_Aufgabe11", input: "setpc green repeat 90[fd 3 rt 1] rt 90 repeat 90[fd 3 rt 1] rt 90", editor: "" },
    { identifier: "Kapitel2_Seite25_Beispiel6", input: "repeat 5[setpc green fd 150 rt 36 setpc blue fd 150 rt 36]", editor: "" },
    { identifier: "Kapitel2_Seite26_Aufgabe12a", input: "repeat 6[setpc orange fd 100 rt 360/12 setpc yellow fd 100 rt 360/12]", editor: "" },
    { identifier: "Kapitel2_Seite26_Aufgabe12b", input: "repeat 4[setpc black fd 200 rt 360/8 setpc white fd 200 rt 360/8]", editor: "" },
    { identifier: "Kapitel2_Seite26_Aufgabe12c", input: "repeat 36/2[setpc green fd 40 rt 10 setpc blue fd 40 rt 10]", editor: "" },
    { identifier: "Kapitel2_Seite28_Beispiel7", input: "setpc red repeat 5[fd 200 bk 200 rt 90 fd 1 lt 90 wait 5]", editor: "" },
    { identifier: "Kapitel2_Seite28_Aufgabe13", input: "setpc red fd 100 wait 10 rt 90 fd 1 rt 90 fd 100 wait 10 lt 90 fd 1 lt 90 fd 100 wait 10 rt 90 fd 1 rt 90 fd 100 wait 10 lt 90 fd 1 lt 90 fd 100", editor: "" },
    { identifier: "Kapitel2_Seite28_Aufgabe14a", input: "repeat 10[fd 300 bk 300 rt 90 fd 1 lt 90]", editor: "" },
    { identifier: "Kapitel2_Seite28_Aufgabe14b", input: "repeat 15[fd 150 bk 150 rt 90 fd 1 lt 90]", editor: "" },
    { identifier: "Kapitel2_Seite28_Aufgabe14c", input: "repeat 25[fd 400 bk 400 rt 90 fd 1 lt 90]", editor: "" },
    { identifier: "Kapitel2_Seite28_Beispiel8", input: "setpc green repeat 100[fd 100 bk 100 rt 90 fd 1 lt 90] setpc blue repeat 200[fd 200 bk 200 rt 90 fd 1 lt 90]", editor: "" },
    { identifier: "Kapitel2_Seite29_Aufgabe15", input: "setpc white lt 90 fd 400 rt 90 repeat 4[setpc brown repeat 150[fd 150 bk 150 rt 90 fd 1 lt 90] setpc yellow repeat 150[fd 150 bk 150 rt 90 fd 1 lt 90]]", editor: "" },
    { identifier: "Kapitel2_Seite29_Aufgabe16a", input: "setpc darkgreen repeat 400[fd 100 bk 100 rt 90 fd 1 lt 90] lt 90 fd 400 rt 90 fd 100 setpc magenta repeat 400[fd 100 bk 100 rt 90 fd 1 lt 90] lt 90 fd 400 rt 90 fd 100 setpc orange repeat 400[fd 100 bk 100 rt 90 fd 1 lt 90] lt 90 fd 400 rt 90 fd 100", editor: "" },
    { identifier: "Kapitel2_Seite29_Aufgabe16b", input: "setpc orange repeat 100[fd 400 bk 400 rt 90 fd 1 lt 90] setpc white repeat 100[fd 400 bk 400 rt 90 fd 1 lt 90] setpc orange repeat 100[fd 400 bk 400 rt 90 fd 1 lt 90]", editor: "" },
    { identifier: "Kapitel2_Seite29_Aufgabe17", input: "setpc blue repeat 400[fd 400 bk 400 rt 90 fd 1 lt 90] lt 90 fd 350 rt 90 fd 150 setpc yellow repeat 300[fd 100 bk 100 rt 90 fd 1 lt 90] lt 90 fd 100 lt 90 fd 100 rt 90 repeat 300[fd 100 bk 100 rt 90 fd 1 lt 90]", editor: "" },
    { identifier: "Kapitel2_Seite31_Kontrollaufgabe1a", input: "setpc white lt 90 fd 400 rt 180 repeat 3[setpc purple fd 150 setpc white fd 100 setpc green fd 150 setpc white fd 100]", editor: "" },
    { identifier: "Kapitel2_Seite31_Kontrollaufgabe1b", input: "setpc white rt 90 bk 300 repeat 3[setpc red fd 100 lt 90 fd 100 bk 100 rt 90 setpc black fd 100 lt 90 fd 100 bk 100 rt 90]", editor: "" },
    { identifier: "Kapitel2_Seite31_Kontrollaufgabe1c", input: "lt 90 repeat 3[setpc orange fd 300 bk 300 rt 180/5 setpc blue fd 300 bk 300 rt 180/5]", editor: "" },
    { identifier: "Kapitel2_Seite31_Kontrollaufgabe2a", input: "setpc green repeat 100[fd 200 rt 90 fd 1 rt 90 fd 200 lt 180]", editor: "" },
    { identifier: "Kapitel2_Seite31_Kontrollaufgabe2b", input: "setpc green repeat 100[fd 200 rt 90 fd 1 rt 90 fd 200 lt 90 fd 1 lt 90]", editor: "" },
    { identifier: "Kapitel2_Seite31_Kontrollaufgabe2c", input: "setpc green repeat 199[fd 200 rt 90 fd 1 rt 90 fd 200 lt 180]", editor: "" },
    { identifier: "Kapitel2_Seite31_Kontrollaufgabe3a", input: "repeat 12/3[setpc red fd 100 rt 360/12 setpc green fd 100 rt 360/12 setpc blue fd 100 rt 360/12]", editor: "" },
    { identifier: "Kapitel2_Seite31_Kontrollaufgabe3b", input: "repeat 6/3[setpc red fd 300 rt 360/6 setpc green fd 300 rt 360/6 setpc blue fd 300 rt 360/6]", editor: "" },
    { identifier: "Kapitel2_Seite31_Kontrollaufgabe3c", input: "repeat 360/3[setpc red fd 4 rt 1 setpc green fd 4 rt 1 setpc blue fd 4 rt 1] ", editor: "" },
    { identifier: "Kapitel3_Seite33_Beispiel1", input: "quad100", editor: "to quad100 \n repeat 4[fd 100 rt 90] \n end" },
    { identifier: "Kapitel3_Seite34_Aufgabe1a", input: "sechseck150", editor: "to sechseck150 \n repeat 6[fd 150 rt 60] \n end" },
    { identifier: "Kapitel3_Seite34_Aufgabe1b", input: "sechseck150 fd 150 rt 180 setpc red sechseck150", editor: "to sechseck150 \n repeat 6[fd 150 rt 60] \n end" },
    { identifier: "Kapitel3_Seite34_Beispiel2", input: "repeat 3[quad100 fd 100]", editor: "to quad100 \n repeat 4[fd 100 rt 90] \n end" },
    { identifier: "Kapitel3_Seite35_Aufgabe2a", input: "setpc white lt 90 fd 400 rt 90 setpc red repeat 8[quad100 rt 90 fd 100 lt 90]", editor: "to quad100 \n repeat 4[fd 100 rt 90] \n end" },
    { identifier: "Kapitel3_Seite35_Aufgabe2b", input: "setpc brown repeat 4[quad100 rt 90]", editor: "to quad100 \n repeat 4[fd 100 rt 90] \n end" },
    { identifier: "Kapitel3_Seite35_Aufgabe2c", input: "setpc green repeat 4[quad100 fd 100 rt 90 fd 100 lt 90]", editor: "to quad100 \n repeat 4[fd 100 rt 90] \n end" },
    { identifier: "Kapitel3_Seite35_Aufgabe2d", input: "setpc blue rt 45 repeat 4[quad100 fd 100 rt 90 fd 100 lt 90]", editor: "to quad100 \n repeat 4[fd 100 rt 90] \n end" },
    { identifier: "Kapitel3_Seite36_Aufgabe3a", input: "setpc yellow repeat 5[sechseck70 lt 60 bk 70 lt 60 bk 70 rt 120]", editor: "to sechseck70 \n repeat 6[fd 70 rt 60] \n end" },
    { identifier: "Kapitel3_Seite36_Aufgabe3b", input: "sechseck70 rt 120 sechseck70 rt 120 sechseck70 rt 120 fd 70 lt 60 sechseck70", editor: "to sechseck70 \n repeat 6[fd 70 rt 60] \n end" },
    { identifier: "Kapitel3_Seite36_Aufgabe4", input: "repeat 8[quad150 rt 90]", editor: "to quad150 \n repeat 7[fd 150 rt 90] \n end" },
    { identifier: "Kapitel3_Seite37_Aufgabe5a", input: "kreuz200", editor: "to kreuz200 \n repeat 4[fd 200 bk 200 rt 90] \n end" },
    { identifier: "Kapitel3_Seite37_Aufgabe5b", input: "repeat 3[kreuz200 rt 360/12]", editor: "to kreuz200 \n repeat 4[fd 200 bk 200 rt 90] \n end" },
    { identifier: "Kapitel3_Seite37_Aufgabe6", input: "rt 30 repeat 9 [dreieckneu100 rt 120]", editor: "to dreieckneu100 \n repeat 5[fd 100 rt 120] \n end" },
    { identifier: "Kapitel3_Seite38_Beispiel3a", input: "repeat 12[kreis rt 30]", editor: "to kreis \n setpc orange \n repeat 360[fd 3 rt 1] \n end" },
    { identifier: "Kapitel3_Seite38_Aufgabe7a", input: "repeat 36[kreis rt 360/36]", editor: "to kreis \n setpc orange \n repeat 360[fd 3 rt 1] \n end" },
    { identifier: "Kapitel3_Seite38_Aufgabe7b", input: "repeat 8[kreis rt 360/8]", editor: "to kreis \n setpc orange \n repeat 360[fd 3 rt 1] \n end" },
    { identifier: "Kapitel3_Seite38_Aufgabe7c", input: "repeat 90[kreis rt 360/90]", editor: "to kreis \n setpc orange \n repeat 360[fd 3 rt 1] \n end" },
    { identifier: "Kapitel3_Seite38_Aufgabe8a", input: "kreisum360", editor: "to kreisum360 \n setpc blue \n repeat 360[fd 1 rt 1] \n end" },
    { identifier: "Kapitel3_Seite38_Aufgabe8b", input: "repeat 12[kreis rt 360/12] repeat 36[kreisum360 rt 10]", editor: "to kreis \n setpc orange \n repeat 360[fd 3 rt 1] \n end \n \n to kreisum360 \n setpc blue \n repeat 360[fd 1 rt 1] \n end" },
    { identifier: "Kapitel3_Seite39_Beispiel3b", input: "blueterot", editor: "to blatt \n repeat 100[fd 2 rt 1] \n rt 80 \n repeat 100[fd 2 rt 1] \n rt 80 \n end \n \n to blueterot \n setpc red \n repeat 8[blatt rt 360/8] \n end" },
    { identifier: "Kapitel3_Seite39_Aufgabe9a", input: "blueterot2", editor: "to blatt \n repeat 100[fd 2 rt 1] \n rt 80 \n repeat 100[fd 2 rt 1] \n rt 80 \n end \n \n to blueterot2 \n setpc red \n repeat 5[blatt rt 360/5] \n end" },
    { identifier: "Kapitel3_Seite39_Aufgabe9b", input: "blueterot3", editor: "to blatt \n repeat 100[fd 2 rt 1] \n rt 80 \n repeat 100[fd 2 rt 1] \n rt 80 \n end \n \n to blueterot3 \n setpc red \n repeat 12[blatt rt 360/12] \n end" },
    { identifier: "Kapitel3_Seite39_Aufgabe9c", input: "blueterot4", editor: "to blatt \n repeat 100[fd 2 rt 1] \n rt 80 \n repeat 100[fd 2 rt 1] \n rt 80 \n end \n \n to blueterot4 \n setpc red \n repeat 60[blatt rt 360/60] \n end" },
    { identifier: "Kapitel3_Seite39_Aufgabe10", input: "blatt", editor: "to blatt \n repeat 2[halbblatt] \n end \n \n to halbblatt \n repeat 100[fd 2 rt 1] \n rt 80 \n end" },
    { identifier: "Kapitel3_Seite39_Aufgabe11a", input: "kreisausgemalt", editor: "to kreis3 \n repeat 36[fd 15 rt 10] \n end \n \n to kreisausgemalt \n repeat 360[kreis3 rt 1] \n end" },
    { identifier: "Kapitel3_Seite39_Aufgabe11b", input: "setpc darkblue kreisausgemalt repeat 180[fd 1.5 rt 1] wait 10 setpc red kreisausgemalt repeat 180[fd 1.5 rt 1] wait 10 setpc yellow kreisausgemalt", editor: "to kreis3 \n repeat 36[fd 15 rt 10] \n end \n \n to kreisausgemalt \n repeat 360[kreis3 rt 1] \n end" },
    { identifier: "Kapitel3_Seite40_Beispiel3c", input: "blume", editor: "to blatt \n repeat 100[fd 2 rt 1] \n rt 80 \n repeat 100[fd 2 rt 1] \n rt 80 \n end \n \n to stiel \n repeat 5[fd 400 bk 400 rt 90 fd 1 lt 90] \n end \n \n to blume \n setpc white bk 300 \n setpc green stiel \n fd 100 \n rt 30 blatt lt 30 \n fd 70 lt 90 fd 5 rt 90 \n lt 120 blatt rt 120 \n fd 230 \n rt 90 fd 2.5 lt 90 \n blueterot \n end \n \n to blueterot \n setpc red \n repeat 8[blatt rt 360/8] \n end" },
    { identifier: "Kapitel3_Seite40_Aufgabe12a", input: "blume2", editor: "to blume2 \n setpc white bk 300 \n setpc brown stiel \n fd 100 \n rt 30 blatt lt 30 \n fd 70 lt 90 fd 5 rt 90 \n lt 120 blatt rt 120 \n fd 230 \n rt 90 fd 2.5 lt 90 \n blueteblau \n end \n \n to blueteblau \n setpc blue \n repeat 8[blatt rt 360/8] \n end \n \n to blatt \n repeat 100[fd 2 rt 1] \n rt 80 \n repeat 100[fd 2 rt 1] \n rt 80 \n end \n \n to stiel \n repeat 5[fd 400 bk 400 rt 90 fd 1 lt 90] \n end" },
    { identifier: "Kapitel3_Seite40_Aufgabe12b", input: "blume3", editor: "to blatt \n repeat 100[fd 2 rt 1] \n rt 80 \n repeat 100[fd 2 rt 1] \n rt 80 \n end \n \n to blume3 \n setpc white bk 300 \n setpc green stiellang \n rt 30 blatt lt 150 blatt rt 120 \n fd 100 rt 30 blatt \n lt 30 fd 70 lt 90 fd 5 rt 90 \n lt 120 blatt rt 120 \n fd 230 rt 90 fd 2.5 lt 90 fd 100 \n blueterot \n end \n \n to stiellang \n repeat 5[fd 500 bk 500 rt 90 fd 1 lt 90] \n end \n \n to blueterot \n setpc red \n repeat 8[blatt rt 360/8] \n end" },
    { identifier: "Kapitel3_Seite40_Aufgabe12c", input: "blume4", editor: "to blatt \n repeat 100[fd 2 rt 1] \n rt 80 \n repeat 100[fd 2 rt 1] \n rt 80 \n end \n \n to blume4 \n setpc white bk 300 \n setpc green stiel \n fd 100 \n rt 30 blatt lt 30 \n fd 70 lt 90 fd 5 rt 90 \n lt 120 blatt rt 120 \n fd 230 \n rt 90 fd 2.5 lt 90 \n blueterot12blaetter \n end \n \n to stiel \n repeat 5[fd 400 bk 400 rt 90 fd 1 lt 90] \n end \n \n to blueterot12blaetter \n setpc red \n repeat 12[blatt rt 360/12] \n end" },
   
   
   
   
   
   
    { identifier: "Kapitel3_Seite40_Aufgabe12d", input: "blume5", editor: "to blattklein \n repeat 100[fd 1 rt 1] \n rt 80 \n repeat 100[fd 1 rt 1] \n rt 80 \n end \n \n to blatt \n repeat 100[fd 2 rt 1] \n rt 80 \n repeat 100[fd 2 rt 1] \n rt 80 \n end \n \n to blueterot \n setpc red \n repeat 8[blatt rt 360/8] \n end \n \n to stiel \n repeat 5[fd 400 bk 400 rt 90 fd 1 lt 90] \n end \n \n to blume5 \n setpc white bk 300 \n setpc green stiel \n fd 100 \n rt 30 blatt lt 30 \n fd 70 lt 90 fd 5 rt 90 \n lt 120 blatt rt 120 \n fd 230 \n rt 90 fd 2.5 lt 90 \n blueterot bluetegelb24 \n end \n \n to bluetegelb24 \n setpc yellow \n repeat 24[blattklein rt 360/24] \n end" },
    { identifier: "Kapitel3_Seite41_Aufgabe14", input: "repeat 4[setpc green quad100 rt 90 fd 100 lt 90 setpc blue dreieck100 rt 90 fd 100 lt 90]", editor: "to dreieck100 \n rt 30 \n repeat 3[fd 100 rt 120] \n end \n \n to quad100 \n repeat 4[fd 100 rt 90] \n end" },
    { identifier: "Kapitel3_Seite41_Beispiel4a", input: "quadfarb50", editor: "to quadfarb50 \n repeat 50[fd 50 bk 50 rt 90 fd 1 lt 90] \n end" },
    { identifier: "Kapitel3_Seite42_Aufgabe15", input: "quadrat100", editor: "to quadrat100 \n setpc red \n repeat 100[fd 100 bk 100 rt 90 fd 1 lt 90] \n end" },
    { identifier: "Kapitel3_Seite42_Beispiel4b", input: "zeile1 setpc white rt 90 fd 50 lt 90 zeile2", editor: "to quadfarb50 \n repeat 50[fd 50 bk 50 rt 90 fd 1 lt 90] \n end \n \n to zeile1 \n repeat 4[setpc brown quadfarb50 setpc yellow quadfarb50] \n end \n \n to zeile2 \n repeat 4[setpc yellow quadfarb50 setpc brown quadfarb50] \n end" },
    { identifier: "Kapitel3_Seite42_Aufgabe16", input: "zeile1aufgabe16 setpc white rt 90 fd 300 lt 90 zeile2aufgabe16", editor: "to quadfarb50 \n repeat 50[fd 50 bk 50 rt 90 fd 1 lt 90] \n end \n \n to zeile1aufgabe16 \n repeat 4 [setpc brown quadfarb50 setpc yellow quadfarb50] zurueckgehen \n end \n \n to zeile2aufgabe16 \n repeat 4 [setpc yellow quadfarb50 setpc brown quadfarb50] zurueckgehen \n end \n \n to zurueckgehen \n setpc white bk 50 lt 90 fd 400 rt 90 fd 50 \n end" },
    { identifier: "Kapitel3_Seite42_Beispiel4c", input: "schach50", editor: "to quadfarb50 \n repeat 50[fd 50 bk 50 rt 90 fd 1 lt 90] \n end \n \n to zeile1 \n repeat 4[setpc brown quadfarb50 setpc yellow quadfarb50] \n end \n \n to zeile2 \n repeat 4[setpc yellow quadfarb50 setpc brown quadfarb50] \n end \n \n to schach50 \n setpc white lt 45 fd 300 rt 45 \n repeat 4[zeile1 setpc white bk 50 lt 90 fd 400 rt 90 zeile2 setpc white bk 50 lt 90 fd 400 rt 90] \n end" },
    { identifier: "Kapitel3_Seite43_Aufgabe17a", input: "schach50", editor: "to quadfarb50 \n repeat 50[fd 50 bk 50 rt 90 fd 1 lt 90] \n end \n \n to schach50 \n setpc white lt 45 fd 300 rt 45 \n repeat 4[zeile1 setpc white bk 50 lt 90 fd 400 rt 90 zeile2 setpc white bk 50 lt 90 fd 400 rt 90] \n end \n \n to zeile1 \n repeat 4[setpc red quadfarb50 setpc blue quadfarb50] \n end \n \n to zeile2 \n repeat 4[setpc blue quadfarb50 setpc red quadfarb50] \n end" },
    { identifier: "Kapitel3_Seite43_Aufgabe17b", input: "schach50", editor: "to quadfarb50 \n repeat 50[fd 50 bk 50 rt 90 fd 1 lt 90] \n end \n \n to schach50 \n setpc white lt 45 fd 300 rt 45 \n repeat 5[zeile1 setpc white bk 50 lt 90 fd 500 rt 90 zeile2 setpc white bk 50 lt 90 fd 500 rt 90] \n end \n \n to zeile1 \n repeat 5[setpc red quadfarb50 setpc blue quadfarb50] \n end \n \n to zeile2 \n repeat 5[setpc blue quadfarb50 setpc red quadfarb50] \n end" },
    { identifier: "Kapitel3_Seite43_Aufgabe17c", input: "schach55", editor: "to quadfarb55 \n repeat 55 [fd 55 bk 55 rt 90 fd 1 lt 90] \n end \n \n to zeileneu1 \n repeat 4 [setpc brown quadfarb55 setpc yellow \n quadfarb55] \n end \n \n to zeileneu2 \n repeat 4 [setpc yellow quadfarb55 setpc brown \n quadfarb55] \n end \n \n to doppelzeile \n zeileneu1 \n setpc white bk 55 lt 90 fd 440 rt 90 \n zeileneu2 \n setpc white bk 55 lt 90 fd 440 rt 90 \n end \n \n to schach55 \n setpc white lt 45 fd 300 rt 45 \n repeat 4 [doppelzeile] \n end" },
    { identifier: "Kapitel3_Seite43_Aufgabe18", input: "schach16mal16", editor: "to zeiledop1 \n zeile1 zeile1 \n end \n \n to zeiledop2 \n zeile2 zeile2 \n end \n \n to zeile1  \n repeat 4[setpc brown quadfarb50 setpc yellow quadfarb50] \n end \n \n to zeile2  \n repeat 4[setpc yellow quadfarb50 setpc brown quadfarb50] \n end \n \n to quadfarb50 \n repeat 50 [fd 50 bk 50 rt 90 fd 1 lt 90] \n end \n \n to doppelzeile16 \n zeiledop1 \n setpc white bk 50 lt 90 fd 800 rt 90 \n zeiledop2 \n setpc white bk 50 lt 90 fd 800 rt 90 \n end \n \n to schach16mal16 \n setpc white lt 45 fd 600 rt 45 \n repeat 8 [doppelzeile16] \n end" },
    { identifier: "Kapitel3_Seite43_Aufgabe19a", input: "blume", editor: "to zwoelfeck \n repeat 12 [fd 30 rt 360/12] \n end \n \n to kreisblau \n setpc blue \n repeat 360 [zwoelfeck wait 0.25 rt 1] \n end \n \n to blume \n setpc white bk 300 \n setpc green stiel \n fd 100 \n rt 30 blatt lt 30 \n fd 70 lt 90 fd 5 rt 90 \n lt 120 blatt rt 120 \n fd 230 \n rt 90 fd 2.5 lt 90 \n blueterot kreisblau \n end \n \n to stiel \n repeat 5[fd 400 bk 400 rt 90 fd 1 lt 90] \n end \n \n to blatt \n repeat 100[fd 2 rt 1] \n rt 80 \n repeat 100[fd 2 rt 1] \n rt 80 \n end \n \n to blueterot \n setpc red \n repeat 8[blatt rt 360/8] \n end" },
    { identifier: "Kapitel3_Seite43_Aufgabe19b", input: "herz", editor: "to zwoelfeck \n repeat 12 [fd 30 rt 360/12] \n end \n \n to herz \n setpc red \n repeat 200 [zwoelfeck wait 0.25 rt 1] \n end" },
    { identifier: "Kapitel3_Seite43_Aufgabe19c", input: "apfel", editor: "to zwoelfeck \n repeat 12 [fd 30 rt 360/12] \n end \n \n to apfel \n setpc brown repeat 5 [fd 180 bk 180 rt 90 fd 1 lt 90] \n setpc yellow repeat 240 [zwoelfeck rt 1] \n end" },
    { identifier: "Kapitel3_Seite43_Aufgabe20", input: "gitter7mal10", editor: "to quad30 \n repeat 4[fd 30 rt 90] \n end \n \n to zeile10 \n repeat 10[quad30 rt 90 fd 30 lt 90] \n end \n \n to gitter7mal10 \n repeat 7[zeile10 position] \n end \n \n to position \n lt 90 fd 300 rt 90 fd 30 \n end" },
    { identifier: "Kapitel3_Seite44_Aufgabe21", input: "strasse", editor: "to quadbraun \n setpc brown \n repeat 5 [fd 100 rt 90] \n end \n \n to dreieckrot \n setpc red \n repeat 3 [fd 100 rt 120] \n end \n \n to haus \n quadbraun lt 60 \n dreieckrot \n setpc brown lt 30 bk 100 \n end \n \n to hausreihe \n repeat 5 [haus rt 90 fd 100 setpc white fd 100 \n lt 90] \n end \n \n to strasse \n setpc white lt 90 fd 400 rt 90 \n hausreihe \n setpc white bk 250 lt 90 fd 1000 rt 90 \n hausreihe \n end" },
    { identifier: "Kapitel3_Seite45_Beispiel5", input: "setpc black quad100 setpc white quad100 cs setpc black quad100 wait 10 setpc white quad100 cs repeat 50[setpc black quad100 wait 10 setpc white quad100 rt 90 fd 5 lt 90]", editor: "to quad100 \n repeat 4[fd 100 rt 90] \n end" },
    { identifier: "Kapitel3_Seite46_Aufgabe22", input: "repeat 50[setpc black quad100 wait 10 setpc white quad100 lt 90 fd 5 rt 90]", editor: "to quad100 \n repeat 4[fd 100 rt 90] \n end" },
    { identifier: "Kapitel3_Seite46_Aufgabe23", input: "repeat 50[setpc black quad100 wait 10 setpc white quad100 rt 90 fd 10 lt 90]", editor: "to quad100 \n repeat 4[fd 100 rt 90] \n end" },
    { identifier: "Kapitel3_Seite46_Aufgabe24", input: "repeat 50[setpc black quad100 wait 5 setpc white quad100 rt 90 fd 5 lt 90]", editor: "to quad100 \n repeat 4[fd 100 rt 90] \n end" },
    { identifier: "Kapitel3_Seite46_Aufgabe25", input: "ht repeat 5[setpc green kreisfarbig setpc blue kreisfarbig] st", editor: "to kreisfarbig \n repeat 360[quad100 rt 1 wait 0.5] \n end \n \n to quad100 \n repeat 4[fd 100 rt 90] \n end" },
    { identifier: "Kapitel3_Seite46_Aufgabe26", input: "ht repeat 50[wechsel] st", editor: "to wechsel \n setpc red achteck50 wait 10 setpc white achteck50 fd 5 setpc brown achteck50 wait 10 setpc white achteck50 fd 5 \n end \n \n to achteck50 \n repeat 8[fd 50 rt 360/8] \n end" },
    { identifier: "Kapitel3_Seite47_Beispiel6", input: "ht repeat 180 [setpc red quad100 wait 10 setpc white quad100 fd 6 rt 2] st", editor: "to quad100 \n repeat 4[fd 100 rt 90] \n end" },
    { identifier: "Kapitel3_Seite47_Aufgabe27", input: "ht repeat 10[kreisbahn] st", editor: "to kreisbahn \n repeat 180 [setpc red quad100 wait 10 setpc white quad100 fd 10 rt 2] \n end \n \n to quad100 \n repeat 4[fd 100 rt 90] \n end" },
    { identifier: "Kapitel3_Seite47_Aufgabe28", input: "ht sonne setpc white lt 90 fd 300 rt 90 repeat 20 [umlauf] st", editor: "to sonne \n setpc yellow \n repeat 360 [zwoelfeck rt 1] \n end \n \n to zwoelfeck  \n repeat 12 [fd 30 rt 360/12] \n end \n \n to planet \n repeat 36 [fd 10 rt 10] \n end \n \n to umlauf \n repeat 60 [setpc blue planet wait 10 setpc white \n planet fd 6.28*300/60 rt 6] \n end" },
    { identifier: "Kapitel3_Seite47_Beispiel7", input: "lauftier", editor: "to kopf1 \n fd 100 lt 90 fd 40 bk 40 rt 90 \n repeat 2[rt 120 fd 100] \n lt 60 \n end \n \n to kopf2 \n fd 140 bk 40 \n repeat 2[rt 120 fd 100] \n lt 60 \n end \n \n to beine \n rt 60 bk 100 fd 100 \n rt 60 bk 100 fd 100 \n lt 120 \n end \n \n to tier1 \n fd 100 rt 90 \n bk 100 fd 500 lt 90 \n kopf1 \n fd 100 rt 90 fd 100 \n beine \n fd 200 \n beine \n fd 100 rt 90 \n end \n \n to tier2 \n fd 100 lt 45 fd 100 bk 100 rt 45 \n rt 90 fd 400 lt 90 \n kopf2 \n fd 100 rt 90 fd 100 \n rt 90 bk 100 fd 100 lt 90 \n fd 200 \n rt 90 bk 100 fd 100 lt 90 \n fd 100 rt 90 \n end \n \n to lauftier \n ht \n setpc white rt 90 bk 600 lt 90 \n repeat 100 [setpc brown tier1 wait 10 setpc white tier1 rt 90 fd 5 lt 90 setpc brown tier2 wait 10 setpc white tier2 rt 90 fd 5 lt 90] \n st \n end" },
    { identifier: "Kapitel3_Seite48_Aufgabe30", input: "lauftiernachlinks", editor: "to lauftiernachlinks \n ht \n setpc white rt 90 fd 400 lt 90 \n repeat 100 [doppelschritt_links] st \n end \n \n to doppelschritt_links \n setpc brown tier1 wait 10 setpc white tier1 \n lt 90 fd 5 rt 90 \n setpc brown tier2 wait 10 setpc white tier2 \n lt 90 fd 5 rt 90 \n end \n \n to kopf1 \n fd 100 lt 90 fd 40 bk 40 rt 90 \n repeat 2[rt 120 fd 100] \n lt 60 \n end \n \n to kopf2 \n fd 140 bk 40 \n repeat 2[rt 120 fd 100] \n lt 60 \n end \n \n to beine \n rt 60 bk 100 fd 100 \n rt 60 bk 100 fd 100 \n lt 120 \n end \n \n to tier1 \n fd 100 rt 90 \n bk 100 fd 500 lt 90 \n kopf1 \n fd 100 rt 90 fd 100 \n beine \n fd 200 \n beine \n fd 100 rt 90 \n end \n \n to tier2 \n fd 100 lt 45 fd 100 bk 100 rt 45 \n rt 90 fd 400 lt 90 \n kopf2 \n fd 100 rt 90 fd 100 \n rt 90 bk 100 fd 100 lt 90 \n fd 200 \n rt 90 bk 100 fd 100 lt 90 \n fd 100 rt 90 \n end \n \n to lauftier \n ht \n setpc white rt 90 bk 600 lt 90 \n repeat 100 [setpc brown tier1 wait 10 setpc white tier1 rt 90 fd 5 lt 90 setpc brown tier2 wait 10 setpc white tier2 rt 90 fd 5 lt 90] \n st \n end \n \n to lauftier2 \n ht \n setpc white rt 90 fd 400 lt 90 \n repeat 100 [setpc brown tier1 wait 10 setpc white tier1 lt 90 fd 5 rt 90 setpc brown tier2 wait 10 setpc white tier2 lt 90 fd 5 rt 90] \n st \n end" },
    { identifier: "Kapitel3_Seite49_Aufgabe31", input: "fig_lauf", editor: "to kopf \n repeat 7 [fd 100 rt 90] \n rt 90 fd 30 lt 90 \n fd 30 rt  90 setpc white fd 30 \n setpc black repeat 4 [fd 3 rt 90] \n setpc white rt 90 fd 30 rt 90 \n setpc black fd 60 rt 90 fd 50 rt 90 \n end \n \n to kopf_loeschen \n setpc white \n repeat 7 [fd 100 rt 90] \n rt 90 fd 30 lt 90 \n fd 30 rt 90 fd 30 \n repeat 4 [fd 3 rt 90] \n rt 90 fd 30 rt 90 \n fd 60 rt 90 fd 100 bk 50 rt 90 \n end \n \n to koerper1 \n bk 100 \n rt 90 fd 100 bk 200 fd 100 lt 90 \n bk 100 rt 140 \n fd 150 bk 150 rt 80 fd 150 bk 150 \n rt 140 fd 200 lt 90 fd 50 rt 90 \n end \n \n to koerper2 \n bk 100 rt 140 \n fd 100 bk 100 rt 80 fd 100 bk 100 lt 40 \n fd 100 lt 20 \n fd 150 bk 150 rt 40 fd 150 bk 150 \n rt 160 fd 200 lt 90 fd 50 rt 90 \n end \n \n to koerper3  \n bk 330 fd 330 \n lt 90 fd 50 rt 90 \n end \n \n to schritt3 \n setpc black \n kopf koerper1 wait 10 kopf_loeschen koerper1 rt 90 fd 5 lt 90 \n setpc black \n kopf koerper2 wait 10 kopf_loeschen koerper2 rt 90 fd 5 lt 90 \n setpc black \n kopf koerper3 wait 10 kopf_loeschen koerper3 rt 90 fd 5 lt 90 \n end \n \n to fig_lauf \n setpc white lt 90 fd 400 rt 90 ht \n repeat 30 [schritt3] st \n end" },
    { identifier: "Kapitel3_Seite51_Kontrollaufgabe1", input: "dreimalhalbkreis", editor: "to ball \n repeat 8 [fd 320/8 rt 360/8] \n end \n \n to schritt \n setpc blue ball wait 10 \n setpc white ball \n end \n \n to halbkreis_lauf \n setpc white \n repeat 18 [lt 90 fd 50 rt 90 schritt \n rt 90 fd 50 lt 90 fd 10 rt 10] \n end \n \n to dreimalhalbkreis \n repeat 3 [halbkreis_lauf rt 180] \n end" },
    { identifier: "Kapitel3_Seite51_Kontrollaufgabe3", input: "schach40_12", editor: "to quadfarb40 \n repeat 40 [fd 40 bk 40 rt 90 fd 1 lt 90] \n end \n \n to zeile_eins \n repeat 6 [setpc green quadfarb40 setpc yellow quadfarb40] \n end \n \n to zeile_zwei \n repeat 6 [setpc yellow quadfarb40 setpc green quadfarb40] \n end \n \n to doppelzeile \n zeile_eins \n setpc white bk 40 lt 90 fd 12 * 40 rt 90 \n zeile_zwei \n setpc white bk 40 lt 90 fd 12 * 40 rt 90 \n end \n \n to schach40_12 \n setpc white lt 45 fd 350 rt 45 \n repeat 5 [doppelzeile] \n end" },
    { identifier: "Kapitel3_Seite51_Kontrollaufgabe4", input: "rollrobot", editor: "to fig1 \n lt 90 fd 50 \n lt 45 fd 100 bk 100 \n rt 90+45 fd 200 bk 100 \n rt 90 fd 100 lt 90 \n fd 100 bk 200 \n lt 45 bk 100 fd 100 \n lt 45 fd 50 rt 90 \n end \n \n to fig2 \n lt 45 \n repeat 4 [fd 100 lt 45 fd 100 bk 100 rt 45+90] \n rt 45 \n end \n \n to fig3 \n lt 90 fd 50 rt 90 fd 100 rt 90 fd 50 rt 90 fig1 \n lt 90 fd 50 rt 90 fd 100 rt 90 fd 50 rt 90 \n end \n \n to dreischritt \n setpc black fig1 wait 10 setpc white fig1 rt 90 \n fd 5 lt 90 \n setpc black fig2 wait 10 setpc white fig2 rt 90 \n fd 5 lt 90 \n setpc black fig3 wait 10 setpc white fig3 rt 90 \n fd 5 lt 90 \n end \n \n to rollrobot \n setpc white lt 90 fd 300 rt 90 \n ht repeat 50 [dreischritt] st \n end" },
    { identifier: "Kapitel3_Seite51_Kontrollaufgabe5", input: "rotblau", editor: "to rechteckfarb100_500 \n repeat 500 [fd 100 bk 100 rt 90 fd 1 lt 90 wait 1] \n lt 90 fd 500 rt 90 \n end \n \n to rotblau \n setpc red rechteckfarb100_500 \n setpc white bk 200 \n setpc red rechteckfarb100_500 \n setpc blue rechteckfarb100_500 \n end" },
    { identifier: "Kapitel3_Seite51_Kontrollaufgabe6", input: "reifen", editor: "to apfelstiel \n setpc brown \n repeat 5 [fd 200 bk 200 rt 90 fd 1 lt 90] \n end \n \n to apfel \n repeat 220 [repeat 12 [fd 50 rt 360/12] rt 1 wait 1] \n end \n \n to reifen \n apfelstiel \n setpc green apfel rt 140 wait 10 \n setpc yellow apfel \n end" },
    { identifier: "Kapitel4_Seite53_Beispiel1", input: "quadrat 100 quadrat 110 quadrat 120 quadrat 130 quadrat 200", editor: "to quadrat :seite \n repeat 4[fd :seite rt 90] \n end" },
    { identifier: "Kapitel4_Seite54_Aufgabe1", input: "sechsecke 50 sechsecke 100 sechsecke 150", editor: "to sechsecke :seite \n repeat 6[fd :seite rt 60] \n end" },
    { identifier: "Kapitel4_Seite54_Aufgabe2", input: "kreise 1.5 kreise 2 kreise 3 kreise 4", editor: "to kreise :gross \n repeat 360[fd :gross rt 1] \n end" },
    { identifier: "Kapitel4_Seite54_Aufgabe3a", input: "rechteck1zu2 100 rechteck1zu2 120 rechteck1zu2 160", editor: "to rechteck1zu2 :seitekurz \n repeat 2[fd :seitekurz rt 90 fd 2*:seitekurz rt 90] \n end" },
    { identifier: "Kapitel4_Seite54_Aufgabe3b", input: "rechteck1zu4 100 rechteck1zu4 120 rechteck1zu4 160 ", editor: "to rechteck1zu4 :seitehor \n repeat 2 [fd :seitehor rt 90 fd 4*:seitehor rt 90] \n end" }, 
    { identifier: "Kapitel4_Seite55_Beispiel2", input: "vieleck 5 vieleck 10 vieleck 20", editor: "to vieleck :eck \n repeat :eck[fd 40 rt 360/:eck] \n end" },
    { identifier: "Kapitel4_Seite55_Aufgabe4", input: "farbigequadrate 100 farbigequadrate 150 farbigequadrate 200 farbigequadrate 250 ", editor: "to farbigequadrate :seite \n setpc red \n repeat :seite [fd :seite bk :seite rt 90 fd 1 \n lt 90] \n end" },
    { identifier: "Kapitel4_Seite55_Aufgabe5", input: "animbeliebiglang 100", editor: "to animbeliebiglang :anzahl \n repeat :anzahl [setpc black quad100 wait 10 setpc white quad100 fd 3] \n end \n \n to quad100 \n repeat 4[fd 100 rt 90] \n end" },
    { identifier: "Kapitel4_Seite55_Aufgabe6", input: "blatt 120 blatt 100 blatt 90", editor: "to blatt :x  \n repeat :x [fd 3 rt 1] rt 180-:x \n repeat :x [fd 3 rt 1] rt 180-:x \n end" },
    { identifier: "Kapitel4_Seite56_Beispiel3", input: "vielecke 3 300 black vielecke 90 10 red vielecke 15 40 green", editor: "to vielecke :eck :seite :farbe \n setpc :farbe repeat :eck [fd :seite rt 360/:eck] \n end" },
    { identifier: "Kapitel4_Seite57_Aufgabe7", input: "setpc blue repeat 20 [fd 30 rt 360/20]", editor: "" },
    { identifier: "Kapitel4_Seite57_Aufgabe8a", input: "vielecke 6 66 blue", editor: "to vielecke :eck :seite :farbe \n setpc :farbe repeat :eck [fd :seite rt 360/:eck] \n end" },
    { identifier: "Kapitel4_Seite57_Aufgabe8b", input: "vielecke 17 71 orange", editor: "to vielecke :eck :seite :farbe \n setpc :farbe repeat :eck [fd :seite rt 360/:eck] \n end" },
    { identifier: "Kapitel4_Seite57_Aufgabe8c", input: "vielecke 100 12 yellow", editor: "to vielecke :eck :seite :farbe \n setpc :farbe repeat :eck [fd :seite rt 360/:eck] \n end" },
    { identifier: "Kapitel4_Seite57_Aufgabe9", input: "gestricheltelinie 100 6 red", editor: "to gestricheltelinie :lang :anzahl :farbe \n rt 90 \n repeat :anzahl [setpc :farbe fd :lang setpc white fd 50] \n end" },
    { identifier: "Kapitel4_Seite57_Aufgabe10", input: "dreiecke 200 red green blue", editor: "to dreiecke :seite :far1 :far2 :far3 \n setpc :far1 fd :seite rt 120 \n setpc :far2 fd :seite rt 120 \n setpc :far3 fd :seite rt 120 \n end" },
    { identifier: "Kapitel4_Seite57_Aufgabe11", input: "rechtecke 200 250 blue", editor: "to rechtecke :seitev :seiteh :farbe \n setpc :farbe \n repeat 2 [fd :seitev rt 90 fd :seiteh rt 90] \n end" },
    { identifier: "Kapitel4_Seite57_Aufgabe12a", input: "dickelinie 400", editor: "to dickelinie :lang \n repeat 5[fd :lang bk :lang rt 90 fd 1 lt 90] lt 90 fd 5 rt 90 \n end" },
    { identifier: "Kapitel4_Seite57_Aufgabe12b", input: "rechteckfarbig 400 20", editor: "to rechteckfarbig :lang :breit \n repeat :breit[fd :lang bk :lang rt 90 fd 1 lt 90] lt 90 fd :breit rt 90 \n end" },
    { identifier: "Kapitel4_Seite57_Aufgabe13", input: "haeuschen red 200", editor: "to haeuschen :farbe :lang  \n setpc :farbe \n repeat 5 [fd :lang rt 90] \n repeat 3 [fd :lang lt 120] \n end" },
    { identifier: "Kapitel4_Seite58_Aufgabe14", input: "tanne 200 150 100", editor: "to tanne :x :y :z \n setpc brown \n lt 90 fd 75 bk 150 fd 75 rt 90 fd 200 \n setpc green \n rt 135 fd :x bk :x rt 90 fd :x bk :x rt 135 \n setpc brown \n fd 150 \n setpc green \n rt 135 fd :y bk :y rt 90 fd :y bk :y rt 135 \n setpc brown \n fd 100 \n setpc green \n rt 135 fd :z bk :z rt 90 fd :z bk :z \n end"},
    { identifier: "Kapitel4_Seite58_Aufgabe15", input: "tripleblatt green 90 90 90 tripleblatt red 80 120 80 ", editor: "to tripleblatt :farbe :x :y :z \n setpc :farbe \n repeat :x [fd 3 rt 1] rt 180 - :x \n repeat :x [fd 3 rt 1] rt 180 - :x \n repeat :y [fd 3 rt 1] rt 180 - :y \n repeat :y [fd 3 rt 1] rt 180 - :y \n repeat 2 [repeat :z [fd 3 rt 1] rt 180 - :z] \n end" },
    { identifier: "Kapitel4_Seite58_Aufgabe16", input: "treppe 15 10 20", editor: "to treppe :vert :hor :anzahl \n repeat :anzahl [fd :vert rt 90 fd :hor lt 90] \n end" },
    { identifier: "Kapitel4_Seite58_Aufgabe17", input: "triplekreis 2 blue red orange", editor: "to triplekreis :gross :far1 :far2 :far3 \n setpc :far1 \n repeat 360 [fd :gross rt 1] repeat 180 [fd :gross rt 1] \n setpc :far2 rt 180 \n repeat 540 [fd :gross rt 1] \n setpc :far3 rt 180 \n repeat 360 [fd :gross rt 1] \n end" },
    { identifier: "Kapitel4_Seite59_Beispiel4", input: "vieleckeab3 2 200 red vieleckeab3 4 250 green", editor: "to vieleckeab3 :eck :seite :farbe \n if :eck > 2 [setpc :farbe repeat :eck [fd :seite rt 360/:eck]] \n end" },
    { identifier: "Kapitel4_Seite60_Aufgabe18", input: "ht quadratgross 5 quadratgross 30 quadratgross 300", editor: "to quadratgross :seite \n if :seite > 10 [repeat 4[fd :seite rt 90]] \n end" },
    { identifier: "Kapitel4_Seite60_Aufgabe19", input: "ht sechseck 20 sechseck 50", editor: "to sechseck :seite \n if 6*:seite >= 180 [repeat 6[fd :seite rt 60 ]] \n end" },
    { identifier: "Kapitel4_Seite60_Aufgabe20", input: "zweiquadrate 150 151 zweiquadrate 200 200", editor: "to zweiquadrate :seite1 :seite2 \n if :seite1 = :seite2 [ \n repeat 7[fd :seite1 rt 90] rt 90 repeat 4 [fd :seite2 rt 90] \n ] \n end" },
    { identifier: "Kapitel4_Seite60_Beispiel5", input: "auswahl 0 auswahl 1 auswahl 2 auswahl 3", editor: "to quad100 \n repeat 4[fd 100 rt 90] \n end \n \n to auswahl :wahl \n if :wahl = 0 [quad100] \n if :wahl = 1 [repeat 4[fd 100 bk 100 rt 90]] \n if :wahl = 2 [repeat 4[quad100 rt 90]] \n end" },
    { identifier: "Kapitel4_Seite61_Aufgabe21", input: "auswahl 0 auswahl 2 auswahl 1", editor: "to quad100 \n repeat 4[fd 100 rt 90] \n end \n \n to dreieck100 \n repeat 3[fd 100 lt 120] \n end \n \n to kreis \n repeat 360[fd 2 rt 1] \n end \n \n to haus \n quad100 fd 100 rt 90 dreieck100 \n end \n \n to auswahl :wahl \n if :wahl < 1 [haus] \n if :wahl = 1 [dreieck100] \n if :wahl > 1 [kreis] \n end" },
    { identifier: "Kapitel4_Seite61_Aufgabe22a", input: "vieleckeklein 6 1000 red vieleckeklein 6 200 blue", editor: "to vieleckeklein :eck :seite :farbe \n if :eck*:seite < 1600 [setpc :farbe repeat :eck [fd :seite rt 360/:eck]] \n end" },
    { identifier: "Kapitel4_Seite61_Aufgabe22b", input: "quadratbeschraenkt 200 quadratbeschraenkt 1000", editor: "to quadratbeschraenkt :seite \n if :seite<400 [repeat 4[fd :seite rt 90]] \n if :seite>=400 [repeat 4[fd 400 rt 90]] \n end" },
    { identifier: "Kapitel4_Seite61_Aufgabe23", input: "vielecke 2 200 vielecke 5 200", editor: "to vielecke :anz :gr \n if :anz > 2[ if :anz*:gr < 1600 [ repeat :anz[fd :gr rt 360/:anz] ] ] \n if :anz <= 2 [ repeat 4[fd 300 rt 90] rt 90 fd 20 lt 90 setpc white fd 200 setpc black repeat 360+180 [fd 0.8 rt 1] lt 90 setpc white fd 120 rt 90 setpc black repeat 360[fd 0.8 rt 1] setpc white fd 170 rt 180 lt 90 fd 200 rt 90 setpc black repeat 180 [fd 2 rt 1]] \n end" },
    { identifier: "Kapitel4_Seite63_Kontrollaufgabe1", input: "hausrund red blue 200 720", editor: "to hausrund :farbdreieck :farbkreis :seite :umfang \n setpc :farbdreieck \n lt 90 fd :seite/2 rt 120 \n repeat 3 [fd :seite rt 120] \n lt 120 bk :seite/2 rt 180 \n setpc :farbkreis \n repeat 360 [fd :umfang/360 rt 1] \n end" },
    { identifier: "Kapitel4_Seite63_Kontrollaufgabe2", input: "waehle red blue 200 720 3", editor: "to programm1 :farbdreieck :farbkreis :seite :umfang \n setpc :farbdreieck \n lt 90 fd :seite/2 rt 120 \n repeat 3 [fd :seite rt 120] \n lt 120 bk :seite/2 rt 180 \n setpc :farbkreis \n repeat 360 [fd :umfang/360 rt 1] \n end \n \n to programm2 :farbdreieck :farbkreis :seite :umfang \n setpc :farbdreieck \n lt 90 fd :seite/2 rt 120 \n repeat 3 [fd :seite rt 120] \n lt 120 bk :seite/2 rt 180 \n setpc :farbkreis \n fd :umfang/8 rt 90 \n repeat 4 [fd :umfang/4 rt 90] \n end \n \n to waehle :farbdreieck :farbkreis :seite :umfang :wahl \n if :wahl = 1 [programm1 :farbdreieck :farbkreis :seite :umfang] \n if :wahl = 2 [programm2 :farbdreieck :farbkreis :seite :umfang] \n if :wahl = 3 [programm1 :farbdreieck :farbkreis :seite :umfang setpc :farbdreieck fd :seite/2 setpc white fd :umfang/2 lt 90 programm2 :farbdreieck :farbkreis :seite :umfang] \n end" },
    { identifier: "Kapitel4_Seite63_Kontrollaufgabe3", input: "sechserreihe 4 100 orange", editor: "to sechserreihe :anzahl :seite :farbe \n setpc :farbe \n rt 30 \n repeat :anzahl [repeat 9 [fd :seite rt 60] rt 180] \n end" },
    { identifier: "Kapitel4_Seite63_Kontrollaufgabe4", input: "vieledreiecke 5 100 green", editor: "to vieledreiecke :anzahl :seite :farbe \n setpc :farbe rt 30 \n repeat :anzahl [repeat 5 [fd :seite rt 120] rt 120] \n wait 10 \n lt 60 fd :seite lt 60 \n fd :seite*(:anzahl -1) \n end" }
];

LogoVisitor.prototype.visitUnitTestBook = async function (ctx) {
    //switch testingmode on, do not wait but instead take a snapshop and continue
    testingMode = true;

    var succeeded = 0;
    var failed = 0;

    //go through all testcases
    for (var i = 0; i < testcases.length; i++) {
        //TODO: Jacqueline - wait for command to finish
        inputComponent.executeCommand(testcases[i].input, testcases[i].editor, false);
        await waitForABit(1000);
        var res = await comparePictures(testcases[i].identifier);
        if (res === "SUCCESS: ") {
            succeeded++;
        } else {
            failed++;
        }

        console.log(res + testcases[i].identifier);
    }
    console.log("total number of succeeded: " + succeeded + " / total number failed: " + failed);

    //go back to normal mode: wait pauses execution
    testingMode = true;
}

async function comparePictures(result) {
    //load canvas picture
    var base64Canvas = getBase64Image(document.getElementById("canvasD"));

    //load reference picture from memory
    var img = new Image();
    img.setAttribute("id", "imgRef");
    img.src = "app/img/testsuite/" + result.toLowerCase() + ".png";
    return new Promise(function (resolve, reject) {
        img.addEventListener('load', function () {
            var base64Reference = getBase64Image(this);

            //compare the two
            if (base64Canvas === base64Reference) {
                resolve("SUCCESS: ");
            } else {
                resolve("FAILURE: ");
            }
        });
    });
}

LogoVisitor.prototype.visitGenerateSolutions = async function (ctx) {
    //download all editors
    for (var i = 0; i < testcases.length; i++) {
        if(testcases[i].editor !== ""){
            inputComponent.et.downloadFile(testcases[i].identifier + ".lgo", testcases[i].editor);
        }
    }
    
    //download all inputs
    for (var i = 0; i < testcases.length; i++) {
        inputComponent.et.downloadFile(testcases[i].identifier + ".txt", testcases[i].input);
    }
}

LogoVisitor.prototype.visitCreateTestCase = async function (ctx) {
    // unit test for exercises in teaching material
    swal({
        title: 'which exercise to test?',
        input: 'select',
        inputOptions: {
            'Kapitel1_SeiteX_Aufgabe1a': 'Kapitell 1 - Aufgabe 1a',
            'Kapitel1_SeiteX_Aufgabe1b': 'Kapitell 1 - Aufgabe 1b',
            'Kapitel1_SeiteX_Aufgabe2': 'Kapitell 1 - Aufgabe 2',
            'Kapitel1_SeiteX_Aufgabe3': 'Kapitell 1 - Aufgabe 3',
            'Kapitel1_SeiteX_Aufgabe4': 'Kapitell 1 - Aufgabe 4',
            'Kapitel1_SeiteX_Aufgabe5a': 'Kapitell 1 - Aufgabe 5a',
            'Kapitel1_SeiteX_Aufgabe5b': 'Kapitell 1 - Aufgabe 5b',
            'Kapitel1_SeiteX_Aufgabe6a': 'Kapitell 1 - Aufgabe 6a',
            'Kapitel1_SeiteX_Aufgabe6b': 'Kapitell 1 - Aufgabe 6b',
            'Kapitel1_SeiteX_Aufgabe7a': 'Kapitell 1 - Aufgabe 7a',
            'Kapitel1_SeiteX_Aufgabe7b': 'Kapitell 1 - Aufgabe 7b',
            'Kapitel1_SeiteX_Aufgabe7b': 'Kapitell 1 - Aufgabe 7b',
            'Kapitel1_SeiteX_Aufgabe8a': 'Kapitell 1 - Aufgabe 8a',
            'Kapitel1_SeiteX_Aufgabe8b': 'Kapitell 1 - Aufgabe 8b',
            'Kapitel1_SeiteX_Aufgabe9a': 'Kapitell 1 - Aufgabe 9a',
            'Kapitel1_SeiteX_Aufgabe9b': 'Kapitell 1 - Aufgabe 9b',
            'Kapitel1_SeiteX_Beispiel2': 'Kapitell 1 - Beispiel 2',
            'Kapitel1_SeiteX_Aufgabe10': 'Kapitell 1 - Aufgabe 10',
            'Kapitel1_SeiteX_Aufgabe11': 'Kapitell 1 - Aufgabe 11',
            'Kapitel1_SeiteX_Aufgabe12': 'Kapitell 1 - Aufgabe 12',
            'Kapitel1_SeiteX_Aufgabe13a': 'Kapitell 1 - Aufgabe 13a',
            'Kapitel1_SeiteX_Aufgabe13b': 'Kapitell 1 - Aufgabe 13b',
            'Kapitel1_SeiteX_Aufgabe13c': 'Kapitell 1 - Aufgabe 13c',
            'Kapitel1_SeiteX_Kontrollaufgabe1': 'Kapitell 1 - Kontrollaufgabe 1',
            'Kapitel1_SeiteX_Kontrollaufgabe2': 'Kapitell 1 - Kontrollaufgabe 2',
            'Kapitel1_SeiteX_Kontrollaufgabe3a': 'Kapitell 1 - Kontrollaufgabe 3a',
            'Kapitel1_SeiteX_Kontrollaufgabe3b': 'Kapitell 1 - Kontrollaufgabe 3b',
            'Kapitel1_SeiteX_Kontrollaufgabe3c': 'Kapitell 1 - Kontrollaufgabe 3c',
            'Kapitel1_SeiteX_Kontrollaufgabe3d': 'Kapitell 1 - Kontrollaufgabe 3d',
            'Kapitel1_SeiteX_Kontrollaufgabe3e': 'Kapitell 1 - Kontrollaufgabe 3e',
            'Kapitel1_SeiteX_Kontrollaufgabe4': 'Kapitell 1 - Kontrollaufgabe 4',
            'Kapitel2_SeiteX_Beispiel1': 'Kapitell 2 - Beispiel 1',
            'Kapitel2_SeiteX_Aufgabe1': 'Kapitell 2 - Aufgabe 1',
            'Kapitel2_SeiteX_Aufgabe2': 'Kapitell 2 - Aufgabe 2',
            'Kapitel2_SeiteX_Aufgabe3a': 'Kapitell 2 - Aufgabe 3a',
            'Kapitel2_SeiteX_Aufgabe3b': 'Kapitell 2 - Aufgabe 3b',
            'Kapitel2_SeiteX_Aufgabe3c': 'Kapitell 2 - Aufgabe 3c',
            'Kapitel2_SeiteX_Beispiel2a': 'Kapitell 2 - Beispiel 2a',
            'Kapitel2_SeiteX_Beispiel2b': 'Kapitell 2 - Beispiel 2b',
            'Kapitel2_SeiteX_Aufgabe4a': 'Kapitell 2 - Aufgabe 4a',
            'Kapitel2_SeiteX_Aufgabe4b': 'Kapitell 2 - Aufgabe 4b',
            'Kapitel2_SeiteX_Aufgabe5a': 'Kapitell 2 - Aufgabe 5a',
            'Kapitel2_SeiteX_Aufgabe5b': 'Kapitell 2 - Aufgabe 5b',
            'Kapitel2_SeiteX_Aufgabe5c': 'Kapitell 2 - Aufgabe 5c',
            'Kapitel2_SeiteX_Aufgabe6a': 'Kapitell 2 - Aufgabe 6a',
            'Kapitel2_SeiteX_Aufgabe6b': 'Kapitell 2 - Aufgabe 6b',
            'Kapitel2_SeiteX_Aufgabe6c': 'Kapitell 2 - Aufgabe 6c',
            'Kapitel2_SeiteX_Aufgabe6d': 'Kapitell 2 - Aufgabe 6d',
            'Kapitel2_SeiteX_Beispiel3': 'Kapitell 2 - Beispiel 3',
            'Kapitel2_SeiteX_Aufgabe7a': 'Kapitell 2 - Aufgabe 7a',
            'Kapitel2_SeiteX_Aufgabe7b': 'Kapitell 2 - Aufgabe 7b',
            'Kapitel2_SeiteX_Aufgabe7c': 'Kapitell 2 - Aufgabe 7c',
            'Kapitel2_SeiteX_Aufgabe7d': 'Kapitell 2 - Aufgabe 7d',
            'Kapitel2_SeiteX_Aufgabe7e': 'Kapitell 2 - Aufgabe 7e',
            'Kapitel2_SeiteX_Aufgabe7f': 'Kapitell 2 - Aufgabe 7f',
            'Kapitel2_SeiteX_Aufgabe8a': 'Kapitell 2 - Aufgabe 8a',
            'Kapitel2_SeiteX_Aufgabe8b': 'Kapitell 2 - Aufgabe 8b',
            'Kapitel2_SeiteX_Beispiel4': 'Kapitell 2 - Beispiel 4',
            'Kapitel2_SeiteX_Aufgabe9a': 'Kapitell 2 - Aufgabe 9a',
            'Kapitel2_SeiteX_Aufgabe9b': 'Kapitell 2 - Aufgabe 9b',
            'Kapitel2_SeiteX_Aufgabe9c': 'Kapitell 2 - Aufgabe 9c',
            'Kapitel2_SeiteX_Aufgabe10': 'Kapitell 2 - Aufgabe 10',
            'Kapitel2_SeiteX_Beispiel5': 'Kapitell 2 - Beispiel 5',
            'Kapitel2_SeiteX_Aufgabe11': 'Kapitell 2 - Aufgabe 11',
            'Kapitel2_SeiteX_Beispiel6': 'Kapitell 2 - Beispiel 6',
            'Kapitel2_SeiteX_Aufgabe12a': 'Kapitell 2 - Aufgabe 12a',
            'Kapitel2_SeiteX_Aufgabe12b': 'Kapitell 2 - Aufgabe 12b',
            'Kapitel2_SeiteX_Aufgabe12c': 'Kapitell 2 - Aufgabe 12c',
            'Kapitel2_SeiteX_Beispiel7': 'Kapitell 2 - Beispiel 7',
            'Kapitel2_SeiteX_Aufgabe13': 'Kapitell 2 - Aufgabe 13',
            'Kapitel2_SeiteX_Aufgabe14a': 'Kapitell 2 - Aufgabe 14a',
            'Kapitel2_SeiteX_Aufgabe14b': 'Kapitell 2 - Aufgabe 14b',
            'Kapitel2_SeiteX_Aufgabe14c': 'Kapitell 2 - Aufgabe 14c',
            'Kapitel2_SeiteX_Beispiel8': 'Kapitell 2 - Beispiel 8',
            'Kapitel2_SeiteX_Aufgabe15': 'Kapitell 2 - Aufgabe 15',
            'Kapitel2_SeiteX_Aufgabe16a': 'Kapitell 2 - Aufgabe 16a',
            'Kapitel2_SeiteX_Aufgabe16b': 'Kapitell 2 - Aufgabe 16b',
            'Kapitel2_SeiteX_Aufgabe17': 'Kapitell 2 - Aufgabe 17',
            'Kapitel2_SeiteX_Kontrollaufgabe1a': 'Kapitell 2 - Kontrollaufgabe 1a',
            'Kapitel2_SeiteX_Kontrollaufgabe1b': 'Kapitell 2 - Kontrollaufgabe 1b',
            'Kapitel2_SeiteX_Kontrollaufgabe1c': 'Kapitell 2 - Kontrollaufgabe 1c',
            'Kapitel2_SeiteX_Kontrollaufgabe2a': 'Kapitell 2 - Kontrollaufgabe 2a',
            'Kapitel2_SeiteX_Kontrollaufgabe2b': 'Kapitell 2 - Kontrollaufgabe 2b',
            'Kapitel2_SeiteX_Kontrollaufgabe2c': 'Kapitell 2 - Kontrollaufgabe 2c',
            'Kapitel2_SeiteX_Kontrollaufgabe3a': 'Kapitell 2 - Kontrollaufgabe 3a',
            'Kapitel2_SeiteX_Kontrollaufgabe3b': 'Kapitell 2 - Kontrollaufgabe 3b',
            'Kapitel2_SeiteX_Kontrollaufgabe3c': 'Kapitell 2 - Kontrollaufgabe 3c',
            'Kapitel3_SeiteX_Beispiel1': 'Kapitell 3 - Beispiel 1',
            'Kapitel3_SeiteX_Aufgabe1a': 'Kapitell 3 - Aufgabe 1a',
            'Kapitel3_SeiteX_Aufgabe1b': 'Kapitell 3 - Aufgabe 1b',
            'Kapitel3_SeiteX_Beispiel2': 'Kapitell 3 - Beispiel 2',
            'Kapitel3_SeiteX_Aufgabe2a': 'Kapitell 3 - Aufgabe 2a',
            'Kapitel3_SeiteX_Aufgabe2b': 'Kapitell 3 - Aufgabe 2b',
            'Kapitel3_SeiteX_Aufgabe2c': 'Kapitell 3 - Aufgabe 2c',
            'Kapitel3_SeiteX_Aufgabe2d': 'Kapitell 3 - Aufgabe 2d',
            'Kapitel3_SeiteX_Aufgabe3a': 'Kapitell 3 - Aufgabe 3a',
            'Kapitel3_SeiteX_Aufgabe3b': 'Kapitell 3 - Aufgabe 3b',
            'Kapitel3_SeiteX_Aufgabe4': 'Kapitell 3 - Aufgabe 4',
            'Kapitel3_SeiteX_Aufgabe5a': 'Kapitell 3 - Aufgabe 5a',
            'Kapitel3_SeiteX_Aufgabe5b': 'Kapitell 3 - Aufgabe 5b',
            'Kapitel3_SeiteX_Aufgabe6': 'Kapitell 3 - Aufgabe 6',
            'Kapitel3_SeiteX_Beispiel3a': 'Kapitell 3 - Beispiel 3a',
            'Kapitel3_SeiteX_Aufgabe7a': 'Kapitell 3 - Aufgabe 7a',
            'Kapitel3_SeiteX_Aufgabe7b': 'Kapitell 3 - Aufgabe 7b',
            'Kapitel3_SeiteX_Aufgabe7c': 'Kapitell 3 - Aufgabe 7c',
            'Kapitel3_SeiteX_Aufgabe8a': 'Kapitell 3 - Aufgabe 8a',
            'Kapitel3_SeiteX_Aufgabe8b': 'Kapitell 3 - Aufgabe 8b',
            'Kapitel3_SeiteX_Beispiel3b': 'Kapitell 3 - Beispiel 3b',
            'Kapitel3_SeiteX_Aufgabe9a': 'Kapitell 3 - Aufgabe 9a',
            'Kapitel3_SeiteX_Aufgabe9b': 'Kapitell 3 - Aufgabe 9b',
            'Kapitel3_SeiteX_Aufgabe9c': 'Kapitell 3 - Aufgabe 9c',
            'Kapitel3_SeiteX_Aufgabe10': 'Kapitell 3 - Aufgabe 10',
            'Kapitel3_SeiteX_Aufgabe11a': 'Kapitell 3 - Aufgabe 11a',
            'Kapitel3_SeiteX_Aufgabe11b': 'Kapitell 3 - Aufgabe 11b',
            'Kapitel3_SeiteX_Beispiel3c': 'Kapitell 3 - Beispiel 3c',
            'Kapitel3_SeiteX_Aufgabe12a': 'Kapitell 3 - Aufgabe 12a',
            'Kapitel3_SeiteX_Aufgabe12b': 'Kapitell 3 - Aufgabe 12b',
            'Kapitel3_SeiteX_Aufgabe12c': 'Kapitell 3 - Aufgabe 12c',
            'Kapitel3_SeiteX_Aufgabe12d': 'Kapitell 3 - Aufgabe 12d',
            'Kapitel3_SeiteX_Aufgabe14': 'Kapitell 3 - Aufgabe 14',
            'Kapitel3_SeiteX_Beispiel4a': 'Kapitell 3 - Beispiel 4a',
            'Kapitel3_SeiteX_Aufgabe15': 'Kapitell 3 - Aufgabe 15',
            'Kapitel3_SeiteX_Beispiel4b': 'Kapitell 3 - Beispiel 4b',
            'Kapitel3_SeiteX_Aufgabe16': 'Kapitell 3 - Aufgabe 16',
            'Kapitel3_SeiteX_Beispiel4c': 'Kapitell 3 - Beispiel 4c',
            'Kapitel3_SeiteX_Aufgabe17a': 'Kapitell 3 - Aufgabe 17a',
            'Kapitel3_SeiteX_Aufgabe17b': 'Kapitell 3 - Aufgabe 17b',
            'Kapitel3_SeiteX_Aufgabe17c': 'Kapitell 3 - Aufgabe 17c',
            'Kapitel3_SeiteX_Aufgabe18': 'Kapitell 3 - Aufgabe 18',
            'Kapitel3_SeiteX_Aufgabe19a': 'Kapitell 3 - Aufgabe 19a',
            'Kapitel3_SeiteX_Aufgabe19b': 'Kapitell 3 - Aufgabe 19b',
            'Kapitel3_SeiteX_Aufgabe19c': 'Kapitell 3 - Aufgabe 19c',
            'Kapitel3_SeiteX_Aufgabe20': 'Kapitell 3 - Aufgabe 20',
            'Kapitel3_SeiteX_Aufgabe21': 'Kapitell 3 - Aufgabe 21',
            'Kapitel3_SeiteX_Beispiel5': 'Kapitell 3 - Beispiel 5',
            'Kapitel3_SeiteX_Aufgabe22': 'Kapitell 3 - Aufgabe 22',
            'Kapitel3_SeiteX_Aufgabe23': 'Kapitell 3 - Aufgabe 23',
            'Kapitel3_SeiteX_Aufgabe24': 'Kapitell 3 - Aufgabe 24',
            'Kapitel3_SeiteX_Aufgabe25': 'Kapitell 3 - Aufgabe 25',
            'Kapitel3_SeiteX_Aufgabe26': 'Kapitell 3 - Aufgabe 26',
            'Kapitel3_SeiteX_Beispiel6': 'Kapitell 3 - Beispiel 6',
            'Kapitel3_SeiteX_Aufgabe27': 'Kapitell 3 - Aufgabe 27',
            'Kapitel3_SeiteX_Aufgabe28': 'Kapitell 3 - Aufgabe 28',
            'Kapitel3_SeiteX_Beispiel7': 'Kapitell 3 - Beispiel 7',
            'Kapitel3_SeiteX_Aufgabe29': 'Kapitell 3 - Aufgabe 29',
            'Kapitel3_SeiteX_Aufgabe30': 'Kapitell 3 - Aufgabe 30',
            'Kapitel3_SeiteX_Aufgabe31': 'Kapitell 3 - Aufgabe 31',
            'Kapitel3_SeiteX_Kontrollaufgabe1': 'Kapitell 3 - Kontrollaufgabe 1',
            'Kapitel3_SeiteX_Kontrollaufgabe3': 'Kapitell 3 - Kontrollaufgabe 3',
            'Kapitel3_SeiteX_Kontrollaufgabe4': 'Kapitell 3 - Kontrollaufgabe 4',
            'Kapitel3_SeiteX_Kontrollaufgabe5': 'Kapitell 3 - Kontrollaufgabe 5',
            'Kapitel3_SeiteX_Kontrollaufgabe6': 'Kapitell 3 - Kontrollaufgabe 6',
            'Kapitel4_SeiteX_Beispiel1': 'Kapitell 4 - Beispiel 1',
            'Kapitel4_SeiteX_Aufgabe1': 'Kapitell 4 - Aufgabe 1',
            'Kapitel4_SeiteX_Aufgabe2': 'Kapitell 4 - Aufgabe 2',
            'Kapitel4_SeiteX_Aufgabe3a': 'Kapitell 4 - Aufgabe 3a',
            'Kapitel4_SeiteX_Aufgabe3b': 'Kapitell 4 - Aufgabe 3b',
            'Kapitel4_SeiteX_Beispiel2': 'Kapitell 4 - Beispiel 2',
            'Kapitel4_SeiteX_Aufgabe4': 'Kapitell 4 - Aufgabe 4',
            'Kapitel4_SeiteX_Aufgabe5': 'Kapitell 4 - Aufgabe 5',
            'Kapitel4_SeiteX_Aufgabe6': 'Kapitell 4 - Aufgabe 6',
            'Kapitel4_SeiteX_Beispiel3': 'Kapitell 4 - Beispiel 3',
            'Kapitel4_SeiteX_Aufgabe7': 'Kapitell 4 - Aufgabe 7',
            'Kapitel4_SeiteX_Aufgabe8a': 'Kapitell 4 - Aufgabe 8a',
            'Kapitel4_SeiteX_Aufgabe8b': 'Kapitell 4 - Aufgabe 8b',
            'Kapitel4_SeiteX_Aufgabe8c': 'Kapitell 4 - Aufgabe 8c',
            'Kapitel4_SeiteX_Aufgabe9': 'Kapitell 4 - Aufgabe 9',
            'Kapitel4_SeiteX_Aufgabe10': 'Kapitell 4 - Aufgabe 10',
            'Kapitel4_SeiteX_Aufgabe11': 'Kapitell 4 - Aufgabe 11',
            'Kapitel4_SeiteX_Aufgabe12a': 'Kapitell 4 - Aufgabe 12a',
            'Kapitel4_SeiteX_Aufgabe12b': 'Kapitell 4 - Aufgabe 12b',
            'Kapitel4_SeiteX_Aufgabe13': 'Kapitell 4 - Aufgabe 13',
            'Kapitel4_SeiteX_Aufgabe14': 'Kapitell 4 - Aufgabe 14',
            'Kapitel4_SeiteX_Aufgabe15': 'Kapitell 4 - Aufgabe 15',
            'Kapitel4_SeiteX_Aufgabe16': 'Kapitell 4 - Aufgabe 16',
            'Kapitel4_SeiteX_Aufgabe17': 'Kapitell 4 - Aufgabe 17',
            'Kapitel4_SeiteX_Beispiel6': 'Kapitell 4 - Beispiel 6',
            'Kapitel4_SeiteX_Aufgabe18': 'Kapitell 4 - Aufgabe 18',
            'Kapitel4_SeiteX_Aufgabe19': 'Kapitell 4 - Aufgabe 19',
            'Kapitel4_SeiteX_Beispiel7': 'Kapitell 4 - Beispiel 7',
            'Kapitel4_SeiteX_Aufgabe20': 'Kapitell 4 - Aufgabe 20',
            'Kapitel4_SeiteX_Aufgabe21': 'Kapitell 4 - Aufgabe 21',
            'Kapitel4_SeiteX_Aufgabe22a': 'Kapitell 4 - Aufgabe 22a',
            'Kapitel4_SeiteX_Aufgabe22b': 'Kapitell 4 - Aufgabe 22b',
            'Kapitel4_SeiteX_Aufgabe23': 'Kapitell 4 - Aufgabe 23',
            'Kapitel4_SeiteX_Kontrollaufgabe1': 'Kapitell 4 - Kontrollaufgabe 1',
            'Kapitel4_SeiteX_Kontrollaufgabe2': 'Kapitell 4 - Kontrollaufgabe 2',
            'Kapitel4_SeiteX_Kontrollaufgabe3': 'Kapitell 4 - Kontrollaufgabe 3',
            'Kapitel4_SeiteX_Kontrollaufgabe4': 'Kapitell 4 - Kontrollaufgabe 4'
        },
        inputPlaceholder: 'exercise',
        showCancelButton: false,
        inputValidator: function (value) {
            return new Promise(function (resolve, reject) {
                if (value !== '') {
                    resolve();
                } else {
                    reject('Please select an exercise');
                }
            });
        }
    }).then(function (result) {
        //find unittest and execute
        for (var i = 0; i < testcases.length; i++) {
            if (testcases[i].identifier.toLowerCase() === result.toLowerCase()) {
                //execute input and generate picture
                inputComponent.executeCommand(testcases[i].input, testcases[i].editor, false);

                //Download picture as a reference picture
                setTimeout(function () {
                    //download picture
                    //document.getElementById("download").click();
                }, 2000);

                /*
                setTimeout(function () {
                    //load canvas picture
                    var base64Canvas = getBase64Image(document.getElementById("canvasD"));

                    //load reference picture from memory
                    var img = new Image();
                    img.setAttribute("id", "imgRef");
                    img.src = "app/img/testsuite/" + result.toLowerCase() + ".png";
                    img.addEventListener('load', function () {
                        var base64Reference = getBase64Image(this);

                        //compare the two
                        if (base64Canvas === base64Reference) {
                            console.log("testcase " + result.toLowerCase() + ": success");
                        } else {
                            console.log("testcase " + result.toLowerCase() + ": failure");
                        }
                    }
                    );

                }, 2000);
                */
            }
        }
    });

};

exports.LogoVisitor = LogoVisitor;



//////////////////
// WEBPACK FOOTER
// ./src/app/interpreter/interpreter-input/LogoVisitor.js
// module id = ./src/app/interpreter/interpreter-input/LogoVisitor.js
// module chunks = main